import { r as registerInstance, h, H as Host, c as createEvent, g as getElement } from './index-fac5572a.js';

const cmBannerCss = ":host{display:block}.container{box-sizing:border-box;display:flex;align-items:center;height:56px;padding-left:60px;padding-right:25px;border-radius:3px;box-shadow:1px 2px 3px 0 rgba(0, 0, 0, 0.1);background-color:#fff6ea;background-image:url(\"data:image/svg+xml,%3Csvg width='24' height='20' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M12.868.52l10.277 17.984A1 1 0 0122.277 20H1.723a1 1 0 01-.868-1.496L11.132.519a1 1 0 011.736 0z' fill='%23FFA533' fill-rule='nonzero'/%3E%3Cpath d='M13.5 14v3h-3v-3h3zm.75-9l-1.117 7.5h-2.241L9.75 5h4.5z' fill='%23FFF'/%3E%3C/g%3E%3C/svg%3E\");background-repeat:no-repeat;background-position:25px center}";

const CmBanner = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.appearance = 'warning';
  }
  render() {
    return (h(Host, null, h("div", { class: "container" }, h("div", null, h("slot", null)))));
  }
};
CmBanner.style = cmBannerCss;

const onThemeChange = async (callback, options = {}) => {
  var _a;
  if (window.commonUIContext) {
    if ((_a = options.runOnInit) !== null && _a !== void 0 ? _a : true) {
      callback(window.commonUIContext._getResolvedTheme());
    }
  }
  let context = document.querySelector('cm-context');
  if (context) {
    context.addEventListener('themeChanged', (event) => {
      callback(event.detail.theme);
    });
  }
};

const cmButtonCss = ":host{display:inline-block;user-select:none}div{display:grid;transition:all 0.2s linear;height:35px;min-width:80px;position:relative;cursor:pointer;padding:0 20px 0 20px;border-radius:3px;font-family:var(--cm-font-text);font-size:14px;font-weight:700;line-height:35px;text-decoration:none;text-align:center;}div span{opacity:1;transition:all 0.2s linear;transition-delay:0.2s}div span.disabled{transition-delay:0s}div cm-loader{position:absolute;opacity:0;align-self:center;justify-self:center;transition:all 0.2s linear;transition-delay:0s;pointer-events:none}div.initialRender{transition:none}div:not(.link).loading span{opacity:0;transition-delay:0s}div:not(.link).loading cm-loader{opacity:1;transition-delay:0.2s}div.small{height:22px;line-height:22px;min-width:60px;font-size:13px;padding:0 10px 0 10px}div.disabled,div:not(.link).loading{pointer-events:none;cursor:default}div.disabled span{opacity:0.5}div:focus{outline:none}div.main{background-color:var(--cm-color-ui-light5);border:solid 1px var(--cm-color-ui-light3);color:var(--cm-color-ui-dark4);box-shadow:0px 2px 2px 0px rgba(0, 0, 0, 0.08)}div.main:hover{background-color:var(--cm-color-button-light1);border:solid 1px var(--cm-color-button-light2)}div.main:focus{outline:none}div.main:focus-visible{box-shadow:0px 0px 0px 1px var(--cm-color-focus-inner-neutral2), 0px 0px 0px 4px var(--cm-color-focus-outer-neutral)}div.main:active{background-color:var(--cm-color-ui-light3);border:solid 1px var(--cm-color-button-light3)}div.main.disabled,div.main.loading{background-color:var(--cm-color-button-light4);border:solid 1px var(--cm-color-ui-light3);box-shadow:unset}div.primary{background-color:var(--cm-color-blue-base);border:solid 1px var(--cm-color-button-blue3);color:var(--cm-color-ui-light4);box-shadow:0px 2px 2px 0px rgba(0, 0, 0, 0.35)}div.primary:hover{background-color:var(--cm-color-button-blue3);border:solid 1px var(--cm-color-button-blue4)}div.primary:focus{outline:none}div.primary:focus-visible{box-shadow:0px 0px 0px 1px var(--cm-color-focus-inner-neutral), 0px 0px 0px 4px var(--cm-color-focus-outer-neutral)}div.primary:active{background-color:var(--cm-color-button-blue4);border:solid 1px var(--cm-color-button-blue5)}div.primary.disabled,div.primary.loading{background-color:var(--cm-color-button-blue2);border:solid 1px var(--cm-color-button-blue1);box-shadow:unset}div.secondary{background-color:var(--cm-color-button-light4);border:solid 1px var(--cm-color-ui-light3);color:var(--cm-color-ui-dark4);box-shadow:0px 2px 2px 0px rgba(0, 0, 0, 0.08)}div.secondary:hover{background-color:var(--cm-color-button-light5);border:solid 1px var(--cm-color-ui-light3)}div.secondary:focus{outline:none}div.secondary:focus-visible{box-shadow:0px 0px 0px 1px var(--cm-color-focus-inner-neutral2), 0px 0px 0px 4px var(--cm-color-focus-outer-neutral)}div.secondary:active{background-color:var(--cm-color-button-light6);border:solid 1px var(--cm-color-ui-light3)}div.secondary.disabled,div.secondary.loading{background-color:var(--cm-color-button-light4);border:solid 1px var(--cm-color-ui-light3);box-shadow:unset}div.danger{background-color:var(--cm-color-red-base);border:solid 1px var(--cm-color-button-red3);color:var(--cm-color-ui-light4);box-shadow:0px 2px 2px 0px rgba(0, 0, 0, 0.35)}div.danger:hover{background-color:var(--cm-color-button-red3);border:solid 1px var(--cm-color-button-red4)}div.danger:focus{outline:none}div.danger:focus-visible{box-shadow:0px 0px 0px 1px var(--cm-color-focus-inner-danger), 0px 0px 0px 4px var(--cm-color-focus-outer-danger)}div.danger:active{background-color:var(--cm-color-button-red4);border:solid 1px var(--cm-color-button-red5)}div.danger.disabled,div.danger.loading{background-color:var(--cm-color-button-red2);border:solid 1px var(--cm-color-button-red1);box-shadow:unset}div.link{padding:0;height:unset;min-width:unset;line-height:unset;font-family:var(--cm-font-text);font-size:14px;font-weight:400;color:var(--cm-color-link)}div.link:hover{color:var(--cm-color-link-hover)}div.link:focus{outline:none}div.link:focus-visible{box-shadow:0px 0px 0px 1px var(--cm-color-focus-inner-neutral), 0px 0px 0px 4px var(--cm-color-focus-outer-neutral)}div.link:active{color:var(--cm-color-link-active)}div.link.disabled{opacity:0.5}div.link.Dark{color:var(--cm-color-link-dark)}div.link.Dark:hover{color:var(--cm-color-link-hover-dark)}div.link.Dark:active{color:var(--cm-color-link-active-dark)}";

const CmButton = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.cmPress = createEvent(this, "cmPress", 7);
    this.appearance = 'main';
    this.label = '';
    this.size = 'normal';
    this.disabled = false;
    /**
     * The loading state displays a spinner and effectively disables the button to user input. Does not affect buttons with the `link` appearance.
     */
    this.loading = false;
    this.theme = 'Light';
    this.initialRender = true;
  }
  disabledHandler() {
    if (this.disabled && !this.initialRender) {
      this.el.shadowRoot.querySelector('span').classList.add('disabled');
    }
  }
  /**
   * Triggers the press event. Respects the disabled state unless forced.
   */
  async press(options = {}) {
    if ((!this.disabled &&
      (!this.loading ||
        (this.loading && this.appearance === 'link'))) ||
      options.forcePress) {
      this.cmPress.emit();
    }
  }
  handleClick() {
    if (!this.disabled &&
      (!this.loading || (this.loading && this.appearance === 'link'))) {
      this.press();
    }
  }
  handleKeyDown(event) {
    if (event.key === ' ' || event.key === 'Enter') {
      if (!this.disabled &&
        (!this.loading || (this.loading && this.appearance === 'link'))) {
        this.press();
      }
    }
  }
  componentWillLoad() {
    onThemeChange((theme) => {
      this.theme = theme;
    });
  }
  componentDidRender() {
    requestAnimationFrame(() => {
      this.initialRender = false;
      if (!this.disabled) {
        this.el.shadowRoot
          .querySelector('span')
          .classList.remove('disabled');
      }
    });
  }
  render() {
    let classes = {
      [this.appearance]: true,
      [this.theme]: true,
      [this.size]: true,
      initialRender: this.initialRender,
      disabled: this.disabled,
      loading: this.loading,
    };
    let tabIndex = 0;
    if (this.disabled) {
      tabIndex = -1;
    }
    return (h(Host, null, h("div", { tabindex: tabIndex, class: classes, role: "button", "aria-disabled": this.disabled }, h("cm-loader", { size: "small", color: this.appearance === 'danger' ||
        this.appearance === 'primary'
        ? 'light'
        : 'dark' }), h("span", null, this.label))));
  }
  get el() { return getElement(this); }
  static get watchers() { return {
    "disabled": ["disabledHandler"]
  }; }
};
CmButton.style = cmButtonCss;

const cmCardCss = ":host{display:block}.container{display:grid;grid-auto-rows:minmax(24px, max-content) 1fr max-content;box-sizing:border-box;position:relative;padding:30px;padding-right:40px;border-radius:3px;box-shadow:0 2px 3px 0 rgba(0, 0, 0, 0.1);border:solid 1px var(--cm-color-ui-light5);background-color:var(--cm-color-ui-light4)}.container .content{padding-top:20px}.container .content.hasFooterContent{padding-bottom:20px}.container slot[name=header],.container slot[name=footer]{display:grid;grid-auto-flow:column;justify-items:start;align-content:center}#dismissButton{position:absolute;right:12px;top:12px}";

const CmCard = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.cmDismissed = createEvent(this, "cmDismissed", 7);
    /**
     * Adds a Dismiss-Button to the Card, which fires the `cmDismissed` Event when pressed.
     */
    this.isDismissable = false;
    this.hasFooterContent = false;
  }
  componentDidRender() {
    requestAnimationFrame(() => {
      let footerSlot = this.element.shadowRoot.querySelector('slot[name=footer]');
      if (footerSlot) {
        this.hasFooterContent = footerSlot.assignedElements().length > 0;
      }
    });
  }
  componentDidLoad() {
    let footerSlot = this.element.shadowRoot.querySelector('slot[name=footer]');
    footerSlot.addEventListener('slotchange', () => {
      this.hasFooterContent = footerSlot.assignedElements().length > 0;
    });
  }
  render() {
    const contentClasses = {
      content: true,
      hasFooterContent: this.hasFooterContent,
    };
    return (h(Host, null, h("div", { class: "container" }, h("slot", { name: "header" }), h("div", { class: contentClasses }, h("slot", null)), h("slot", { name: "footer" }), this.isDismissable ? (h("cm-icon-button", { id: "dismissButton", icon: "closeLarge", onCmPress: () => {
        this.cmDismissed.emit();
      } })) : (''))));
  }
  get element() { return getElement(this); }
};
CmCard.style = cmCardCss;

const cmCheckboxCss = ":host{display:inline-block}.container{display:grid;grid-auto-flow:column;grid-auto-columns:max-content 1fr}.container:focus{outline:none}.container:focus-visible .checkbox{box-shadow:0px 0px 0px 1px var(--cm-color-focus-inner-neutral2), 0px 0px 0px 4px var(--cm-color-focus-outer-neutral)}.container:not(.disabled):hover .checkbox{border-color:var(--cm-color-ui-light6)}.checkbox{position:relative;display:inline-block;height:18px;width:18px;background-color:var(--cm-color-ui-light4);border:1px solid var(--cm-color-ui-light3);border-radius:3px;vertical-align:bottom;transition:all 0.2s linear}.checkbox::before{content:\"\";position:absolute;top:0;left:0;bottom:0;right:0;background-image:url(\"data:image/svg+xml,%3Csvg width='14' height='12' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4.743 11.314L0 6.57l1.897-1.897 2.846 2.846L12.103.16 14 2.057z' fill='%233B3B3B' fill-rule='nonzero'/%3E%3C/svg%3E\");background-repeat:no-repeat;background-position:center center;opacity:0;transition:all 0.2s linear}.checkbox::after{content:\"\";position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);width:10px;height:3px;background:#3b3b3b;opacity:0;transition:all 0.2s linear}.checkbox.indeterminate::after{opacity:0.6}.checkbox.indeterminate:hover::after{opacity:0.8}.checkbox.indeterminate:active::after{opacity:1}.checkbox.checked:not(.indeterminate)::before{opacity:0.6}.checkbox.checked:not(.indeterminate):hover::before{opacity:0.8}.checkbox.checked:not(.indeterminate):active::before{opacity:1}.checkbox.disabled{background:var(--cm-color-ui-light1);border-color:var(--cm-color-ui-light5)}.checkbox.disabled.indeterminate::after{opacity:0.5}.checkbox.disabled.checked:not(.indeterminate)::before{opacity:0.5}label{display:inline-block;padding-left:8px;user-select:none;font-family:var(--cm-font-text);font-size:14px;min-height:20px;line-height:20px}label:empty{display:none}";

const CmCheckbox = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.cmInput = createEvent(this, "cmInput", 7);
    this.label = '';
    this.checked = false;
    this.indeterminate = false;
    this.disabled = false;
    /**
     * Enables `cmInput` Events being emitted when the checked attribute changes.
     */
    this.enableAttributeEmit = false;
  }
  checkedChangeHandler() {
    if (this.enableAttributeEmit) {
      this.cmInput.emit({ isChecked: this.checked, triggeredBy: 'API' });
    }
  }
  handleKeyDown(event) {
    if (event.key === ' ') {
      if (!this.disabled) {
        this.toggleCheck({ triggeredBy: 'User' });
        event.preventDefault();
      }
    }
  }
  handleClick() {
    if (!this.disabled) {
      this.toggleCheck({ triggeredBy: 'User' });
    }
  }
  /**
   * Toggles the checked state. Respects the disabled state, unless forced.
   */
  async toggleCheck(options = {}) {
    var _a;
    if (!this.disabled || options.forceToggle) {
      this.checked = !this.checked;
      this.cmInput.emit({
        isChecked: this.checked,
        triggeredBy: (_a = options.triggeredBy) !== null && _a !== void 0 ? _a : 'API',
      });
    }
  }
  /**
   * Sets the checked state to true. Respects the disabled state, unless forced.
   */
  async check(options = {}) {
    var _a;
    if (!this.disabled || options.forceCheck) {
      if (this.checked === false) {
        this.checked = true;
        this.cmInput.emit({
          isChecked: this.checked,
          triggeredBy: (_a = options.triggeredBy) !== null && _a !== void 0 ? _a : 'API',
        });
      }
    }
  }
  /**
   * Sets the checked state to false. Respects the disabled state, unless forced.
   */
  async uncheck(options = {}) {
    var _a;
    if (!this.disabled || options.forceUncheck) {
      if (this.checked === true) {
        this.checked = false;
        this.cmInput.emit({
          isChecked: this.checked,
          triggeredBy: (_a = options.triggeredBy) !== null && _a !== void 0 ? _a : 'API',
        });
      }
    }
  }
  render() {
    let checkboxClasses = {
      checkbox: true,
      indeterminate: this.indeterminate,
      checked: this.checked,
      disabled: this.disabled,
    };
    let tabIndex = 0;
    if (this.disabled) {
      tabIndex = -1;
    }
    return (h(Host, null, h("div", { class: "container", tabindex: tabIndex }, h("div", { class: checkboxClasses, ref: (element) => (this.checkbox = element), role: "checkbox", "aria-disabled": this.disabled }), h("label", null, this.label))));
  }
  static get watchers() { return {
    "checked": ["checkedChangeHandler"]
  }; }
};
CmCheckbox.style = cmCheckboxCss;

const CmContext = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.themeChanged = createEvent(this, "themeChanged", 7);
    this.theme = 'Light';
  }
  themeChangeHandler() {
    if (this.theme !== 'Light' &&
      this.theme !== 'Dark' &&
      this.theme !== 'Automatic') {
      console.error(`Invalid theme property "${this.theme}" set on cm-context!`);
    }
    this.themeChanged.emit({ theme: this._getResolvedTheme() });
  }
  /**
   * Returns the actual theme, resolving "Automatic" to an actual value.
   */
  async getResolvedTheme() {
    return this._getResolvedTheme();
  }
  _getResolvedTheme() {
    let resolvedTheme;
    if (this.theme === 'Automatic') {
      if (window.matchMedia('(prefers-color-scheme: light)').matches) {
        resolvedTheme = 'Light';
      }
      else {
        resolvedTheme = 'Dark';
      }
    }
    else {
      resolvedTheme = this.theme;
    }
    return resolvedTheme;
  }
  componentWillLoad() {
    window.commonUIContext = this;
    window
      .matchMedia('(prefers-color-scheme: light)')
      .addEventListener('change', (event) => {
      if (this.theme === 'Automatic') {
        if (event.matches) {
          this.themeChanged.emit({ theme: 'Light' });
        }
        else {
          this.themeChanged.emit({ theme: 'Dark' });
        }
      }
    });
  }
  render() {
    return (h(Host, { style: { display: 'none' } }, h("slot", null)));
  }
  static get watchers() { return {
    "theme": ["themeChangeHandler"]
  }; }
};

const cmDatalistCss = ":host{display:block}h1{font-family:var(--cm-font-text);font-size:24px;font-weight:500;color:var(--cm-color-ui-light6);margin:0;margin-bottom:40px}h1:empty{display:none}.items{display:grid;position:relative;left:-20px;width:calc(100% + 40px)}";

const CmDatalist = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.headline = '';
    /**
     * Sets the width of the label for all cm-datalist-item's inside this cm-datalist. Expected format is a valid CSS Grid Column value.
     */
    this.labelWidth = '250px';
  }
  componentDidLoad() {
    this.element.shadowRoot
      .querySelector('slot')
      .addEventListener('slotchange', () => {
      this.updateItemLabelWidth();
    });
  }
  updateItemLabelWidth() {
    let items = Array.from(this.element.querySelectorAll('cm-datalist-item'));
    for (let item of items) {
      item.labelWidth = this.labelWidth;
    }
  }
  render() {
    this.updateItemLabelWidth();
    return (h(Host, null, h("h1", null, this.headline), h("div", { class: "items" }, h("slot", null))));
  }
  get element() { return getElement(this); }
};
CmDatalist.style = cmDatalistCss;

const cmDatalistItemCss = "cm-datalist-item:not(:last-child){border-bottom:1px solid var(--cm-color-ui-light5)}.container{display:grid;gap:20px;height:40px;line-height:40px}.container .label{padding-left:20px;opacity:0.9;font-family:var(--cm-font-text);font-size:14px;font-weight:600;color:var(--cm-color-ui-dark4);text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.container .content{padding-right:40px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}";

const CmDatalistItem = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.labelWidth = '250px';
    this.label = '';
  }
  render() {
    return (h(Host, null, h("div", { class: "container", style: { gridTemplateColumns: `${this.labelWidth} 1fr` } }, h("span", { class: "label" }, this.label), h("div", { class: "content" }, h("slot", null)))));
  }
};
CmDatalistItem.style = cmDatalistItemCss;

const cmDropdownCss = ":host{display:inline-grid;position:relative;z-index:998}.container{display:inline-grid;position:relative}.container:focus{outline:none}.trigger{display:grid;align-content:center}.trigger .button{display:inline-grid;user-select:none;transition:all 0.2s linear;height:35px;cursor:pointer;padding:0 20px 0 20px;border-radius:3px;font-family:var(--cm-font-text);font-size:14px;font-weight:700;line-height:35px;text-decoration:none;text-align:center;grid-auto-flow:column;grid-auto-columns:max-content max-content;gap:5px;align-items:center;}.trigger .button.main{background-color:var(--cm-color-ui-light5);border:solid 1px var(--cm-color-ui-light3);color:var(--cm-color-ui-dark4)}.trigger .button.main:hover{background-color:var(--cm-color-button-light1);border:solid 1px var(--cm-color-button-light2)}.trigger .button.main:focus{outline:none}.trigger .button.main:focus-visible{box-shadow:0px 0px 0px 1px var(--cm-color-focus-inner-neutral2), 0px 0px 0px 4px var(--cm-color-focus-outer-neutral)}.trigger .button.main:active{background-color:var(--cm-color-ui-light3);border:solid 1px var(--cm-color-button-light3)}.trigger .button.main.disabled{background-color:var(--cm-color-button-light4);border:solid 1px var(--cm-color-ui-light3);color:rgba(var(--cm-color-ui-dark4-rgb), 0.5);box-shadow:unset}.trigger .button.primary{background-color:var(--cm-color-blue-base);border:solid 1px var(--cm-color-button-blue3);color:var(--cm-color-ui-light4)}.trigger .button.primary:hover{background-color:var(--cm-color-button-blue3);border:solid 1px var(--cm-color-button-blue4)}.trigger .button.primary:focus{outline:none}.trigger .button.primary:focus-visible{box-shadow:0px 0px 0px 1px var(--cm-color-focus-inner-neutral), 0px 0px 0px 4px var(--cm-color-focus-outer-neutral)}.trigger .button.primary:active{background-color:var(--cm-color-button-blue4);border:solid 1px var(--cm-color-button-blue5)}.trigger .button.primary.disabled{background-color:var(--cm-color-button-blue2);border:solid 1px var(--cm-color-button-blue1);color:rgba(var(--cm-color-ui-light4-rgb), 0.5);box-shadow:unset}.trigger .button.secondary{background-color:var(--cm-color-button-light4);border:solid 1px var(--cm-color-ui-light3);color:var(--cm-color-ui-dark4)}.trigger .button.secondary:hover{background-color:var(--cm-color-button-light5);border:solid 1px var(--cm-color-ui-light3)}.trigger .button.secondary:focus{outline:none}.trigger .button.secondary:focus-visible{box-shadow:0px 0px 0px 1px var(--cm-color-focus-inner-neutral2), 0px 0px 0px 4px var(--cm-color-focus-outer-neutral)}.trigger .button.secondary:active{background-color:var(--cm-color-button-light6);border:solid 1px var(--cm-color-ui-light3)}.trigger .button.secondary.disabled{background-color:var(--cm-color-button-light4);border:solid 1px var(--cm-color-ui-light3);color:rgba(var(--cm-color-ui-dark4-rgb), 0.5);box-shadow:unset}.trigger .label{display:grid;grid-auto-flow:column;align-items:center;gap:8px;padding:5px 10px;padding-right:5px;border-radius:5px;cursor:pointer;user-select:none;transition:all 0.2s linear}.trigger .label:focus{outline:none}.trigger .label:hover,.trigger .label:focus-visible{background-color:rgba(var(--cm-color-ui-light5-rgb), 0.5)}.trigger .label .text{font-family:var(--cm-font-text);font-size:15px;font-weight:500;color:var(--cm-color-ui-light6)}.trigger .label cm-icon{transform:translateY(1px)}.flyout{display:grid;opacity:0;pointer-events:none;transition:opacity 150ms linear;z-index:100;position:fixed;padding:5px;border-radius:5px;overflow:hidden;box-shadow:0 1px 10px 0 rgba(0, 0, 0, 0.2);background:#fcfcfc;min-width:max-content;gap:5px}.flyout.open{opacity:1;pointer-events:initial}.flyout .optionGroup:not(:first-child){padding-top:5px;border-top:solid 1px var(--cm-color-ui-light5)}.flyout .optionGroup .title{font-family:var(--cm-font-text);font-size:11px;color:var(--cm-color-ui-light6)}.flyout .optionGroup>.title:not(:empty){padding:5px 15px 0px}.flyout .optionGroup .option{user-select:none;border-radius:3px;padding:8px 15px;font-family:var(--cm-font-text);font-size:14px;color:var(--cm-color-ui-dark4);transition:all 150ms linear}.flyout .optionGroup .option:not(.disabled){cursor:pointer}.flyout .optionGroup .option:hover{background:#f0f0f0}.flyout .optionGroup .option.isDangerous{color:#e30100}.flyout .optionGroup .option.isDisabled{opacity:0.5}.flyout .optionGroup .option>.title{padding-bottom:2px}";

const CmDropdown = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.trigger = {
      type: 'button',
      label: '',
      appearance: 'main',
    };
    this.options = [];
    this.shouldStayOpen = false;
    this.isOpen = false;
  }
  triggerOption(option) {
    if (option.isDisabled) {
      return;
    }
    option.handler({
      preventDismissal: () => {
        this.shouldStayOpen = true;
      },
    });
    if (this.shouldStayOpen) {
      this.shouldStayOpen = false;
    }
    else {
      this.isOpen = false;
      setTimeout(() => {
        this.el.blur();
      }, 10);
    }
  }
  /**
   * Opens the Dropdown.
   */
  async open() {
    this.isOpen = true;
  }
  /**
   * Closes the Dropdown.
   */
  async close() {
    this.isOpen = false;
  }
  /**
   * Triggers an option, as if selected by the user. The Dropdown is _not_ required to be open for this to work.
   */
  async triggerOptionByIndex(optionGroupIndex, optionIndex) {
    this.triggerOption(this.options[optionGroupIndex].options[optionIndex]);
  }
  onBlur() {
    this.isOpen = false;
  }
  _renderOption(option) {
    var _a, _b;
    let optionClasses = {
      option: true,
      isDangerous: (_a = option.isDangerous) !== null && _a !== void 0 ? _a : false,
      isDisabled: (_b = option.isDisabled) !== null && _b !== void 0 ? _b : false,
    };
    return (h("div", { class: optionClasses, onMouseDown: (event) => {
        event.preventDefault();
      }, onClick: () => {
        this.triggerOption(option);
      } }, h("div", { class: "title" }, option.title), option.label));
  }
  render() {
    var _a;
    let flyoutClasses = {
      flyout: true,
      open: this.isOpen,
    };
    let trigger, flyout;
    if (this.trigger) {
      if (this.trigger.type === 'label') {
        trigger = (h("div", { class: "trigger", onClick: () => {
            this.isOpen = !this.isOpen;
          }, onKeyDown: (event) => {
            if (event.key === ' ' || event.key === 'Enter') {
              this.isOpen = !this.isOpen;
            }
          } }, h("div", { class: "label", tabindex: "0" }, h("div", { class: "text" }, this.trigger.label), h("cm-icon", { icon: "down" }))));
      }
      else if (this.trigger.type === 'icon') {
        trigger = (h("div", { class: "trigger" }, h("cm-icon-button", { icon: this.trigger.icon, onCmPress: () => {
            this.isOpen = !this.isOpen;
          } })));
      }
      else {
        let buttonClasses = {
          button: true,
          [this.trigger.appearance]: true,
        };
        let iconColor;
        if (this.trigger.appearance === 'primary') {
          iconColor = 'bright';
        }
        else {
          iconColor = 'dark';
        }
        trigger = (h("div", { class: "trigger" }, h("div", { tabindex: "0", class: buttonClasses, onClick: () => {
            this.isOpen = !this.isOpen;
          }, onKeyDown: (event) => {
            if (event.key === ' ' ||
              event.key === 'Enter') {
              this.isOpen = !this.isOpen;
            }
          } }, this.trigger.label, h("cm-icon", { icon: "down", color: iconColor, ignoreTheme: true }))));
      }
    }
    else {
      console.error('[cm-dropdown] .trigger is not defined!');
    }
    let flyoutOffset = 0;
    if (this.trigger.type === 'icon') {
      flyoutOffset = 6;
    }
    let flyoutStyles = {
      top: `${this.el.getBoundingClientRect().bottom + 10 + flyoutOffset}px`,
    };
    let flyoutWidth = (_a = this.el.shadowRoot.querySelector('.flyout')) === null || _a === void 0 ? void 0 : _a.clientWidth;
    let right = document.documentElement.clientWidth -
      this.el.getBoundingClientRect().right -
      flyoutOffset;
    if (document.documentElement.clientWidth - right - flyoutWidth < 0) {
      flyoutStyles.left = `${this.el.getBoundingClientRect().left}px`;
    }
    else {
      flyoutStyles.right = `${right}px`;
    }
    flyout = (h("div", { class: flyoutClasses, style: flyoutStyles }, this.options.map((option) => {
      return (h("div", { class: "optionGroup" }, h("div", { class: "title" }, option.title), option.options.map((option) => {
        return this._renderOption(option);
      })));
    })));
    return (h(Host, null, h("div", { class: "container" }, trigger, flyout)));
  }
  get el() { return getElement(this); }
};
CmDropdown.style = cmDropdownCss;

const cmEntityListCss = ":host{display:block;overflow:hidden}.container{background:var(--cm-color-ui-light2);z-index:1;position:relative;max-height:100%;height:100%;display:grid;grid-auto-rows:max-content 1fr}.header{display:grid;gap:35px 0px;grid-template-areas:\"headline      buttons\" \"columnHeaders columnHeaders\";background:var(--cm-color-ui-light2);position:relative}.header.entitiesAreScrolled{box-shadow:inset 0px -1px 0px var(--cm-color-ui-light5)}.header .headline{grid-area:headline;font-family:var(--cm-font-text);font-size:24px;font-weight:500;color:var(--cm-color-ui-light6)}.header .buttons{display:grid;grid-auto-flow:column;grid-area:buttons;align-items:center;justify-content:end;gap:10px}.header .buttons .search{transition:all 0.2s linear;display:grid;height:32px;min-width:32px;grid-auto-columns:32px;border-radius:16px;grid-auto-flow:column;align-items:center;justify-content:center;background-color:rgba(216, 220, 227, 0)}.header .buttons .search input{display:none}.header .buttons .search input::placeholder{font-style:italic;opacity:0.7}.header .buttons .search.open{grid-auto-columns:1fr 32px;justify-content:space-between;width:180px;background-color:rgba(216, 220, 227, 0.5)}.header .buttons .search.open input{display:unset;appearance:none;min-width:0px;border:none;background:transparent;outline:none;padding-left:12px;padding-right:6px;font-family:var(--cm-font-text);font-size:14px;color:var(--cm-color-ui-dark4)}.header .buttons .search cm-icon-button{justify-self:center}.header .buttons cm-button{justify-self:end}.header .columnHeaders{grid-area:columnHeaders;box-sizing:border-box;display:grid;padding:0px 20px 15px;gap:15px;min-height:35px;position:relative}.header .columnHeaders .loader{position:absolute;top:0;right:0;bottom:0;left:0;z-index:1;display:grid;padding-top:40px;justify-content:center;background-color:rgba(247, 248, 250, 0.7)}.header .columnHeaders cm-checkbox{transition:all 0.2s linear;opacity:0}.header .columnHeaders cm-checkbox.visible{opacity:1}.header .columnHeaders:hover cm-checkbox{opacity:1}.header .columnHeaders .columnHeader{box-sizing:border-box;display:grid;grid-auto-flow:column;grid-auto-columns:minmax(0, max-content);gap:5px;align-items:center;font-family:var(--cm-font-text);font-size:14px;font-weight:400;color:var(--cm-color-ui-light6)}.header .columnHeaders .columnHeader:not(:empty){cursor:pointer}.header .columnHeaders .columnHeader span{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.entities{position:relative;box-sizing:border-box;display:grid;grid-auto-rows:max-content;gap:15px;z-index:1;overflow-y:auto}.entities.scrollPadding:after{content:\"\";height:20px;display:inline-block}.entities .entity{box-sizing:border-box;display:grid;min-height:60px;padding:0px 20px;gap:15px;transition:background-color 0.2s linear, box-shadow 0.2s linear;background-color:var(--cm-color-ui-light4);border-radius:3px;border:solid 1px var(--cm-color-ui-light5);box-shadow:0 1px 4px 0 rgba(0, 0, 0, 0.1)}.entities .entity cm-dropdown{transition:all 0.2s linear;opacity:0}.entities .entity cm-checkbox{transition:all 0.2s linear;opacity:0}.entities .entity cm-checkbox.visible{opacity:1}.entities .entity.hasPress:hover{background-color:rgba(176, 186, 199, 0.15)}.entities .entity.selected{box-shadow:0px 0px 0px 2px var(--cm-color-blue-base), 0 1px 4px 0 rgba(0, 0, 0, 0.1);background-color:var(--cm-color-focus-inner-neutral)}.entities .entity.selected cm-checkbox{opacity:1}.entities .entity:hover cm-dropdown,.entities .entity:focus cm-dropdown,.entities .entity:focus-within cm-dropdown{opacity:1}.entities .entity:hover cm-checkbox,.entities .entity:focus cm-checkbox,.entities .entity:focus-within cm-checkbox{opacity:1}.entities .entity .cell{min-height:60px;box-sizing:border-box;display:grid;align-content:center;gap:10px;font-family:var(--cm-font-text);font-size:15px;font-weight:400;color:var(--cm-color-ui-light6)}.entities .entity .cell span{min-height:20px}.entities .loader{position:absolute;top:0;right:0;bottom:0;left:0;display:grid;justify-content:center;align-content:center;background-color:rgba(247, 248, 250, 0.7)}";

const CmEntityList = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.enableCreateButton = true;
    this.loading = false;
    this.headline = '';
    this.createButtonLabel = '';
    this.createHandler = () => { };
    this.columns = [];
    this.entities = [];
    this.groupOptions = [];
    this.addScrollPadding = false;
    this.selectedEntities = [];
    this.isSearchOpen = false;
    this.filter = '';
    this.entitiesAreScrolled = false;
  }
  componentDidUpdate() {
    var _a;
    (_a = this.element.shadowRoot.querySelector('#searchInput')) === null || _a === void 0 ? void 0 : _a.focus();
  }
  /**
   * Triggers an option of entity at the given index as if selected by the user, if available. Note that the entity index is based of the entity array and ignores all sorting.
   */
  async triggerEntityOption(options) {
    var _a;
    (_a = this.element.shadowRoot.querySelectorAll('.entity cm-dropdown')
      .item(options.entityIndex)) === null || _a === void 0 ? void 0 : _a.triggerOptionByIndex(options.optionGroupIndex, options.optionIndex);
  }
  /**
   * Triggers an option of the group-actions-dropdown as if selected by the user, if available. Needs selected entities to function.
   */
  async triggerGroupOption(optionGroupIndex, optionIndex) {
    var _a;
    (_a = this.element.shadowRoot.querySelector('.header cm-dropdown')) === null || _a === void 0 ? void 0 : _a.triggerOptionByIndex(optionGroupIndex, optionIndex);
  }
  /**
   * Selects all entities.
   */
  async selectAll() {
    this.selectedEntities = [...this.entities];
  }
  /**
   * De-selects all entities.
   */
  async deselectAll() {
    this.selectedEntities = [];
  }
  /**
   * Selects the entity at the given index. Note that the index is based of the entity array and ignores all sorting.
   */
  async selectIndex(index) {
    let targetEntity = this.entities[index];
    if (!this.selectedEntities.includes(targetEntity)) {
      this.selectedEntities = [...this.selectedEntities, targetEntity];
    }
  }
  /**
   * De-selects the entity at the given index. Note that the index is based of the entity array and ignores all sorting.
   */
  async deselectIndex(index) {
    let targetEntity = this.entities[index];
    if (this.selectedEntities.includes(targetEntity)) {
      let selectedEntityIndex = this.selectedEntities.indexOf(targetEntity);
      let newEntities = this.selectedEntities.slice(0);
      newEntities.splice(selectedEntityIndex, 1);
      this.selectedEntities = newEntities;
    }
  }
  render() {
    let loader, entities, columnHeaderIcon, groupDropdown, search;
    for (let i = 0; i < this.selectedEntities.length; i++) {
      let entity = this.selectedEntities[i];
      if (!this.entities.includes(entity)) {
        this.selectedEntities.splice(i, 1);
        i--;
      }
    }
    let gridTemplateColumns = '';
    if (this.groupOptions.length) {
      gridTemplateColumns = `25px ${this.columns
        .map((column) => column.width)
        .join(' ')}`;
    }
    else {
      gridTemplateColumns = this.columns
        .map((column) => column.width)
        .join(' ');
    }
    let sortedEntities = this.entities.slice(0);
    let sorting = null;
    if (this.userSelectedSorting) {
      sorting = this.userSelectedSorting;
    }
    else if (this.defaultSorting) {
      sorting = this.defaultSorting;
    }
    if (sorting !== null) {
      sortedEntities.sort((a, b) => {
        const leftValue = a.data[sorting.columnIndex];
        const rightValue = b.data[sorting.columnIndex];
        if (leftValue.type === 'text' && rightValue.type === 'text') {
          if (sorting.method === 'ascending') {
            return leftValue.content.localeCompare(rightValue.content);
          }
          else {
            return rightValue.content.localeCompare(leftValue.content);
          }
        }
        else {
          return 0;
        }
      });
      if (sorting.method === 'ascending') {
        columnHeaderIcon = h("cm-icon", { icon: "up" });
      }
      else {
        columnHeaderIcon = h("cm-icon", { icon: "down" });
      }
    }
    const createSortingToggle = (index) => {
      return () => {
        var _a, _b;
        if (((_a = this.userSelectedSorting) === null || _a === void 0 ? void 0 : _a.columnIndex) === index) {
          if (this.userSelectedSorting.method === 'ascending') {
            this.userSelectedSorting = {
              columnIndex: index,
              method: 'descending',
            };
          }
          else {
            this.userSelectedSorting = {
              columnIndex: index,
              method: 'ascending',
            };
          }
        }
        else if (((_b = this.defaultSorting) === null || _b === void 0 ? void 0 : _b.columnIndex) === index) {
          if (this.defaultSorting.method === 'ascending') {
            this.userSelectedSorting = {
              columnIndex: index,
              method: 'descending',
            };
          }
          else {
            this.userSelectedSorting = {
              columnIndex: index,
              method: 'ascending',
            };
          }
        }
        else {
          this.userSelectedSorting = {
            columnIndex: index,
            method: 'ascending',
          };
        }
      };
    };
    let filteredEntities = sortedEntities;
    if (this.filter.length) {
      filteredEntities = filteredEntities.filter((entity) => {
        for (let data of entity.data) {
          if (data.type === 'text') {
            if (data.content
              .toLocaleLowerCase()
              .includes(this.filter.toLocaleLowerCase())) {
              return true;
            }
          }
        }
        return false;
      });
    }
    if (this.loading) {
      loader = (h("div", { class: "loader", style: {
          zIndex: (filteredEntities.length + 1).toString(),
        } }, h("cm-loader", { size: "normal" })));
    }
    entities = filteredEntities.map((entity, index) => {
      let entityClasses = {
        entity: true,
        scrollPadding: this.addScrollPadding,
        selected: this.selectedEntities.includes(entity),
        hasPress: typeof entity.onPress === 'function',
      };
      return (h("div", { class: entityClasses, style: {
          gridTemplateColumns: gridTemplateColumns,
          cursor: entity.onPress ? 'pointer' : 'default',
          zIndex: (filteredEntities.length - index).toString(),
        }, onClick: entity.onPress }, this.groupOptions.length ? (h("div", { class: "cell" }, h("cm-checkbox", { class: {
          visible: this.selectedEntities.length > 0,
        }, onClick: (event) => {
          event.preventDefault();
          event.stopPropagation();
        }, checked: this.selectedEntities.includes(entity), onCmInput: () => {
          if (this.selectedEntities.includes(entity)) {
            let index = this.selectedEntities.indexOf(entity);
            let newEntities = this.selectedEntities.slice(0);
            newEntities.splice(index, 1);
            this.selectedEntities = newEntities;
          }
          else {
            this.selectedEntities = [
              ...this.selectedEntities,
              entity,
            ];
          }
        } }))) : (''), entity.data.map((item, index) => {
        var _a, _b;
        let column = this.columns[index];
        let content;
        let itemCSS = {};
        let spanCSS = {};
        let ellipsis;
        if (column.ellipsis === undefined ||
          column.ellipsis == 'off') {
          ellipsis = 'off';
        }
        else {
          ellipsis = column.ellipsis;
        }
        if (item.type === 'text') {
          if (ellipsis === 'left') {
            spanCSS = {
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              direction: 'rtl',
            };
          }
          if (ellipsis === 'right') {
            spanCSS = {
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
            };
          }
          content = (h("span", { style: spanCSS }, item.content));
          if (item.showCopyButton) {
            itemCSS = Object.assign(Object.assign(Object.assign({}, itemCSS), (ellipsis === 'off'
              ? { gridAutoColumns: 'max-content' }
              : {
                gridAutoColumns: 'minmax(0, min-content)',
              })), {
              gridAutoFlow: 'column',
              gap: '10px',
            });
          }
        }
        if (item.type === 'image') {
          content = h("img", { src: item.src });
        }
        if (item.type === 'button') {
          itemCSS = { gridAutoColumns: 'max-content' };
          content = (h("cm-button", { appearance: "link", label: item.label, onClick: (event) => {
              event.preventDefault();
              event.stopPropagation();
            }, onCmPress: item.onPress }));
        }
        if (item.type === 'contextMenu') {
          content = (h("cm-dropdown", { onClick: (event) => {
              event.preventDefault();
              event.stopPropagation();
            }, trigger: {
              type: 'icon',
              icon: 'contextMenu',
            }, options: item.options }));
        }
        return (h("div", { class: "cell", style: Object.assign(Object.assign({}, ((_b = (_a = this.columns[index]) === null || _a === void 0 ? void 0 : _a.overrideCSS) !== null && _b !== void 0 ? _b : {})), itemCSS) }, content, item.type === 'text' && item.showCopyButton ? (h("cm-icon-button", { icon: "copy", onClick: (event) => {
            event.preventDefault();
            event.stopPropagation();
          }, onCmPress: () => {
            navigator.clipboard.writeText(item.content);
          } })) : ('')));
      })));
    });
    if (this.selectedEntities.length && this.groupOptions.length) {
      let label = '';
      if (this.selectedEntities.length === 1) {
        label = '1 item selected';
      }
      else {
        label = `${this.selectedEntities.length} items selected`;
      }
      groupDropdown = (h("cm-dropdown", { trigger: {
          type: 'button',
          appearance: 'primary',
          label: label,
        }, options: this.groupOptions.map((optionGroup) => {
          optionGroup.options.map((option) => {
            let originalHandler = option.handler;
            option.handler = (event) => {
              if (!event.detail) {
                event.detail = {};
              }
              event.detail.selectedEntities =
                this.selectedEntities;
              originalHandler(event);
            };
            return option;
          });
          return optionGroup;
        }) }));
    }
    if (this.isSearchOpen) {
      search = (h("div", { class: "search open" }, h("input", { type: "text", id: "searchInput", placeholder: "Search", onInput: (event) => {
          var _a;
          this.filter = (_a = event.target) === null || _a === void 0 ? void 0 : _a.value;
        } }), h("cm-icon-button", { icon: "closeLarge", onCmPress: () => {
          this.filter = '';
          this.isSearchOpen = false;
        } })));
    }
    else {
      search = (h("div", { class: "search" }, h("cm-icon-button", { icon: "search", onCmPress: () => {
          this.isSearchOpen = true;
        } })));
    }
    let headerClasses = {
      header: true,
      entitiesAreScrolled: this.entitiesAreScrolled,
    };
    return (h(Host, null, h("div", { class: "container" }, h("div", { class: headerClasses }, h("div", { class: "headline" }, this.headline), h("div", { class: "buttons" }, search, groupDropdown, h("cm-button", { disabled: !this.enableCreateButton || this.loading, appearance: this.selectedEntities.length
        ? 'secondary'
        : 'primary', label: this.createButtonLabel, onCmPress: this.createHandler })), this.entities.length ? (h("div", { class: "columnHeaders", style: {
        gridTemplateColumns: gridTemplateColumns,
      } }, this.groupOptions.length ? (h("cm-checkbox", { class: {
        visible: this.selectedEntities.length >
          0,
      }, checked: this.selectedEntities.length ===
        this.entities.length, onCmInput: (event) => {
        if (event.detail.isChecked) {
          this.selectedEntities = [
            ...this.entities,
          ];
        }
        else {
          this.selectedEntities = [];
        }
      } })) : (''), this.columns.map(({ name }, index) => {
      return (h("div", { class: "columnHeader", onClick: name.length
          ? createSortingToggle(index)
          : () => { } }, h("span", null, name), (sorting === null || sorting === void 0 ? void 0 : sorting.columnIndex) === index
        ? columnHeaderIcon
        : ''));
    }), this.loading ? h("div", { class: "loader" }) : '')) : ('')), h("div", { class: "entities", onScroll: (event) => {
        this.entitiesAreScrolled =
          event.target.scrollTop !== 0;
      } }, h("div", { style: {
        display: this.entities.length || this.loading
          ? 'none'
          : 'grid',
      } }, h("slot", { name: "empty" })), entities, loader))));
  }
  get element() { return getElement(this); }
};
CmEntityList.style = cmEntityListCss;

const cmFilterCss = ":host{display:inline-block}.container{display:flex;gap:6px;flex-wrap:wrap}.pill{display:grid;user-select:none;justify-content:center;align-items:center;height:22px;padding:0px 10px;border:solid 1px var(--cm-color-ui-light3);border-radius:11px;background-color:var(--cm-color-ui-light5);font-family:var(--cm-font-text);font-size:13px;color:rgba(69, 70, 78, 0.9);transition:all linear 200ms;white-space:nowrap}.pill:not(.disabled,.active):hover{border:solid 1px var(--cm-color-button-light2);background-color:var(--cm-color-button-light1);cursor:pointer}.pill:focus{outline:none}.pill:focus-visible{box-shadow:0px 0px 0px 1px var(--cm-color-focus-inner-neutral), 0px 0px 0px 4px var(--cm-color-focus-outer-neutral)}.pill.active{color:var(--cm-color-ui-light4);border:solid 1px var(--cm-color-focus-inner-neutral2);background-color:var(--cm-color-blue-base)}.pill.active:focus-visible{box-shadow:0px 0px 0px 1px var(--cm-color-focus-inner-neutral2), 0px 0px 0px 4px var(--cm-color-focus-outer-neutral)}.pill.disabled{color:rgba(69, 70, 78, 0.5);border:solid 1px var(--cm-color-ui-light3);background-color:var(--cm-color-button-light4)}";

const CmFilter = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.cmFilterSelected = createEvent(this, "cmFilterSelected", 7);
    this.filters = [];
    /**
     * The Index of the active filter.
     */
    this.activeFilterIndex = 0;
  }
  render() {
    return (h(Host, null, h("div", { class: "container" }, this.filters.map((item, index) => {
      let tabindex;
      let classes = {
        pill: true,
        active: index === this.activeFilterIndex,
        disabled: item.disabled,
      };
      if (!item.title) {
        item.title = '';
      }
      if (!item.disabled) {
        tabindex = 0;
      }
      return (h("a", { class: classes, tabindex: tabindex, onClick: () => {
          if (!item.disabled &&
            this.activeFilterIndex !== index) {
            this.activeFilterIndex = index;
            this.cmFilterSelected.emit({
              value: item.value,
            });
          }
        }, onKeyDown: (event) => {
          if (!item.disabled &&
            this.activeFilterIndex !== index &&
            event.key === ' ') {
            this.activeFilterIndex = index;
            this.cmFilterSelected.emit({
              value: item.value,
            });
            event.preventDefault();
          }
        }, title: item.title }, item.label));
    }))));
  }
};
CmFilter.style = cmFilterCss;

const cmFooterCss = ":host{display:block}.footer{height:38px;padding:0px 20px;line-height:38px;border-top:1px solid var(--cm-color-ui-light5);background-color:var(--cm-color-ui-light1);font-family:var(--cm-font-text);font-size:12px;font-weight:normal;text-align:right;color:rgba(var(--cm-color-ui-light6-rgb), 0.9)}";

const CmFooter = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.text = '';
  }
  render() {
    return (h(Host, null, h("div", { class: "footer" }, this.text)));
  }
};
CmFooter.style = cmFooterCss;

const cmHeaderCss = ":host{display:block}.header{display:flex;box-sizing:border-box;height:57px;padding:15px 20px;align-content:center;background-color:var(--cm-color-ui-light1);border-bottom:1px solid var(--cm-color-ui-light5)}.left{display:flex;justify-content:flex-start;align-items:center}.right{display:flex;justify-content:flex-end;align-items:center;margin-left:auto}";

const CmHeader = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  render() {
    return (h(Host, null, h("div", { class: "header" }, h("div", { class: "left" }, h("slot", { name: "left" })), h("div", { class: "right" }, h("slot", { name: "right" })))));
  }
};
CmHeader.style = cmHeaderCss;

const cmIconCss = ":host{display:inline-grid}";

const colorMap = {
  bright: {
    Light: '--cm-color-ui-light4',
    Dark: '--cm-color-ui-dark4',
  },
  medium: {
    Light: '--cm-color-ui-light6',
    Dark: '--cm-color-ui-light3',
  },
  dark: {
    Light: '--cm-color-ui-dark4',
    Dark: '--cm-color-ui-light4',
  },
  success: {
    Light: '--cm-color-green-base',
    Dark: '--cm-color-green-base',
  },
  warning: {
    Light: '--cm-color-orange-base',
    Dark: '--cm-color-orange-base',
  },
  danger: {
    Light: '--cm-color-red-base',
    Dark: '--cm-color-red-base',
  },
};
const CmIcon = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.color = 'dark';
    this.ignoreTheme = false;
    this.theme = 'Light';
  }
  componentWillLoad() {
    onThemeChange((theme) => {
      this.theme = theme;
    });
  }
  getVariableValue(name) {
    return getComputedStyle(document.documentElement)
      .getPropertyValue(name)
      .trim();
  }
  getResolvedColor() {
    let resolvedTheme = this.theme;
    if (this.ignoreTheme) {
      resolvedTheme = 'Light';
    }
    return colorMap[this.color][resolvedTheme];
  }
  getIconSVG() {
    let fill = this.getVariableValue(this.getResolvedColor());
    switch (this.icon) {
      case 'check':
        return (h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16" }, h("path", { fill: fill, d: "M5.74339606 13.3137085L1 8.57031244l1.89735842-1.89735842 2.84603764 2.84603763 7.35924554-7.35924552L15 4.05710456z" })));
      case 'close':
        return (h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16" }, h("path", { fill: fill, d: "M13.65685425 3.75735931L9.41421356 8l4.24264069 4.24264069-1.41421356 1.41421356L8 9.41421356l-4.24264069 4.24264069-1.41421356-1.41421356L6.58578644 8 2.34314575 3.75735931l1.41421356-1.41421356L8 6.58578644l4.24264069-4.24264069 1.41421356 1.41421356z" })));
      case 'closeLarge':
        return (h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, h("path", { fill: fill, d: "M16.1282588 4.8145503l-5.18568546 5.1847426 5.18568545 5.1861568-.94280908.9428091L10 10.94186622 4.8145503 16.1282588l-.9428091-.94280908 5.18568546-5.18615682-5.18568545-5.1847426.94280908-.94280908L10 9.05671955l5.1854497-5.18497834.9428091.94280908z" })));
      case 'contextMenu':
        return (h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, h("path", { fill: fill, d: "M10 14.5c.82842712 0 1.5.6715729 1.5 1.5s-.67157288 1.5-1.5 1.5-1.5-.6715729-1.5-1.5.67157288-1.5 1.5-1.5zm0-6c.82842712 0 1.5.67157288 1.5 1.5s-.67157288 1.5-1.5 1.5-1.5-.67157288-1.5-1.5.67157288-1.5 1.5-1.5zm0-6c.82842712 0 1.5.67157288 1.5 1.5s-.67157288 1.5-1.5 1.5S8.5 4.82842712 8.5 4s.67157288-1.5 1.5-1.5z" })));
      case 'copy':
        return (h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16" }, h("g", { fill: fill }, h("path", { d: "M7.23076923 1L8.922 2.692l-4.22969231.00030769V12.8461538H4c-.55228475 0-1-.4477152-1-1V2c0-.55228475.44771525-1 1-1h3.23076923z" }), h("path", { d: "M9.76923077 3.53846154l1.69123077 1.692h-.018l.865.874v-.028L14 7.76923077v6.61538463c0 .5522847-.4477152 1-1 1H6.53846154c-.55228475 0-1-.4477153-1-1V4.53846154c0-.55228475.44771525-1 1-1h3.23076923zm-.00076923 1.692l-2.53769231.00030769v8.46153847h5.07692308l-.00023077-5.92384616-2.53823077.00076923-.00076923-2.53876923z" }))));
      case 'delete':
        return (h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16" }, h("path", { fill: fill, d: "M13.5 3v1h-1v9c0 1.1045695-.8954305 2-2 2h-5c-1.1045695 0-2-.8954305-2-2V4h-1V3c0-.55228475.44771525-1 1-1h2c0-.55228475.44771525-1 1-1h3c.55228475 0 1 .44771525 1 1h2c.5522847 0 1 .44771525 1 1zm-8 1v8c0 .5522847.44771525 1 1 1h3c.55228475 0 1-.4477153 1-1V4h-5zm2 8h1-1zm-1-7h1v7h-1V5zm2 0h1v7h-1V5z" })));
      case 'document':
        return (h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16" }, h("path", { fill: fill, d: "M8 1l2 2h-.022L11 4.033V4l1.999 1.999L13 14c0 .5522847-.44771525 1-1 1H4c-.55228475 0-1-.4477153-1-1V2c0-.55228475.44771525-1 1-1h4zm0 2H5v10h6V6H8V3z" })));
      case 'down':
        return (h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16" }, h("path", { fill: fill, d: "M8.00017911 11.44956836L3.05043164 6.49982089 4.4646452 5.08560733l3.5355339 3.53553391 3.5355339-3.5355339 1.41421357 1.41421356-4.94974746 4.94974746z" })));
      case 'edit':
        return (h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16" }, h("path", { fill: fill, d: "M3 11l1.99792969 2.0035156-2.99324219 1.0007617L3 11zm9.8-10L15 3.20221356 6.2 12 4 9.79832288 12.8 1z" })));
      case 'email':
        return (h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, h("path", { fill: fill, d: "M2 5.00883682l7.63444351 6.28967368c.21047699.1723514.51330549.1723514.72378239 0l7.6373222-6.20512138v9.76070298c0 .3155146-.2557657.5712803-.5712803.5712803H2.57128033C2.25576569 15.4253724 2 15.1696067 2 14.8540921V5.00883682zM17.4242678 4c.0284184.00338075.0565021.0091046.0839832.01713808L9.99779079 10.1171548 2.57128033 4z" })));
      case 'external':
        return (h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16" }, h("path", { fill: fill, d: "M8 2v1.4H3.4v9.2h9.2V8.48515907H14V14H2V2h6zm6 0v5.20391037L12.203 5.205 8.70710678 8.70185425 7.29289322 7.28764069 10.863 3.716 9.32042868 2H14z" })));
      case 'help':
        return (h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, h("path", { fill: fill, d: "M10 0c5.5228475 0 10 4.4771525 10 10s-4.4771525 10-10 10S0 15.5228475 0 10 4.4771525 0 10 0zm.9914286 13.9890867H8.99297424v1.9984543h1.99845436v-1.9984543zm-.99925061-9.99222487c-2.2082904 0-3.99686183 1.78861826-3.99686183 3.99686182h1.99845433c0-1.09915691.89929743-1.99845433 1.99845433-1.99845433 1.09915688 0 1.99840748.89934426 1.99840748 1.99850117 0 1.99845433-2.99765806 1.74861827-2.99765806 4.99611241h1.99845436c0-2.2482436 2.9976581-2.4980328 2.9976581-4.99611241 0-2.2082904-1.7886183-3.99690866-3.99690871-3.99690866z" })));
      case 'hide':
        return (h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16" }, h("g", { fill: fill }, h("path", { d: "M8.0467033 6.79591837c-1.0230179 0-1.85439561.82345982-1.85439561 1.83673469s.83137771 1.8367347 1.85439561 1.8367347c1.0230179 0 1.8543956-.82345983 1.8543956-1.8367347s-.83140668-1.83673469-1.8543956-1.83673469z" }), h("path", { d: "M8.0467033 3.85714286c-3.20305242 0-5.93844062 1.980225-7.0467033 4.7755102 1.10826268 2.79525536 3.84365088 4.77551024 7.0467033 4.77551024 3.2062354 0 5.9384406-1.98025488 7.0467033-4.77551024-1.1082627-2.7952852-3.8404679-4.7755102-7.0467033-4.7755102zm0 7.95916377c-1.76807941 0-3.20305242-1.42629566-3.20305242-3.18368342 0-1.75738775 1.43497301-3.18365357 3.20305242-3.18365357 1.7680794 0 3.2030524 1.42629567 3.2030524 3.18368342 0 1.75738776-1.434973 3.18365357-3.2030524 3.18365357z" }), h("path", { d: "M2.2593456 12.43994848l9.28077648-9.19238815c.36713821-.36364166.95868705-.36364166 1.32582522 0 .36262971.35917607.36542942.94431527.00625331 1.30694499a.92378857.92378857 0 01-.0062533.0062533L3.5851708 13.75314678c-.36713819.36364164-.95868702.36364164-1.32582522 0-.3626297-.35917608-.3654294-.94431528-.00625331-1.30694497a.92379638.92379638 0 01.00625332-.00625333z" }))));
      case 'information':
        return (h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, h("path", { fill: fill, d: "M10 2c4.418278 0 8 3.581722 8 8s-3.581722 8-8 8-8-3.581722-8-8 3.581722-8 8-8zm1.41538462 7.1H8.03076923v.9h.61538462v3.6H8v.9h4v-.9h-.58461538V9.1zm-1.44-3.6c-.76347693 0-1.38461539.60561-1.38461539 1.35 0 .74439.62113846 1.35 1.38461539 1.35C10.73886154 8.2 11.36 7.59439 11.36 6.85c0-.74439-.62113846-1.35-1.38461538-1.35z" })));
      case 'left':
        return (h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16" }, h("path", { fill: fill, d: "M4.55043164 8.00017911l4.94974747-4.94974747 1.41421356 1.41421356-3.53553391 3.5355339 3.5355339 3.5355339-1.41421356 1.41421357-4.94974746-4.94974746z" })));
      case 'minus':
        return (h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16" }, h("path", { fill: fill, d: "M3 7h10v2H3z" })));
      case 'plus':
        return (h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16" }, h("path", { fill: fill, d: "M9 3v3.999L13 7v2H9v4H7V9H3V7h4V3h2z" })));
      case 'right':
        return (h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16" }, h("path", { fill: fill, d: "M11.44956836 7.99982089l-4.94974747 4.94974747-1.41421356-1.41421356 3.53553391-3.5355339-3.5355339-3.5355339L6.4998209 3.05007343l4.94974746 4.94974746z" })));
      case 'search':
        return (h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, h("path", { fill: fill, d: "M8.6008622 2c3.6455555 0 6.6008622 2.91053515 6.6008622 6.5008622 0 1.44371288-.4778551 2.77750755-1.2862933 3.8563433L18 16.3835568 16.3601272 18l-4.1284855-4.0691809c-1.04160891.6769012-2.28947413 1.0709053-3.6307795 1.0709053C4.95530667 15.0017244 2 12.0911892 2 8.5008622 2 4.91053515 4.95530667 2 8.6008622 2zm0 2C6.05987617 4 4 6.01510464 4 8.5008622c0 2.48575755 2.05987617 4.5008622 4.6008622 4.5008622 2.54098602 0 4.6008622-2.01510465 4.6008622-4.5008622C13.2017244 6.01510464 11.14184822 4 8.6008622 4z" })));
      case 'show':
        return (h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16" }, h("g", { fill: fill }, h("path", { d: "M8.0467033 6.37712288c-1.0230179 0-1.85439561.80618444-1.85439561 1.7982018 0 .99201735.83137771 1.79820179 1.85439561 1.79820179 1.0230179 0 1.8543956-.80618444 1.8543956-1.79820179 0-.99201736-.83140668-1.7982018-1.8543956-1.7982018z" }), h("path", { d: "M8.0467033 3.5C4.84365088 3.5 2.10826268 5.43868182 1 8.17532468c1.10826268 2.73661363 3.84365088 4.67532467 7.0467033 4.67532467 3.2062354 0 5.9384406-1.93871104 7.0467033-4.67532467C13.9851439 5.43868182 11.2529387 3.5 8.0467033 3.5zm0 7.79218831c-1.76807941 0-3.20305242-1.39637337-3.20305242-3.11689286 0-1.72051948 1.43497301-3.11686363 3.20305242-3.11686363 1.7680794 0 3.2030524 1.39637337 3.2030524 3.11689286 0 1.72051948-1.434973 3.11686363-3.2030524 3.11686363z" }))));
      case 'sort':
        return (h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, h("path", { fill: fill, d: "M2 16h6v-2H2v2zM2 4v2h16V4H2zm0 7h11V9H2v2z" })));
      case 'stop':
        return (h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16" }, h("path", { fill: fill, d: "M5.42855151 12.2889629C6.17989881 12.7404026 7.0596333 13 8 13c2.76142375 0 5-2.23857625 5-5 0-.9403667-.2595974-1.82010119-.7110371-2.57144849L5.42855151 12.2889629zm-1.47589089-1.35253622l6.98376606-6.98376606C10.11192198 3.35343147 9.09723516 3 8 3 5.23857625 3 3 5.23857625 3 8c0 1.09723516.35343147 2.11192198.95266062 2.93642668zM8 15c-3.86599325 0-7-3.1340068-7-7 0-3.86599325 3.13400675-7 7-7 3.8659932 0 7 3.13400675 7 7 0 3.8659932-3.1340068 7-7 7z" })));
      case 'up':
        return (h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16" }, h("path", { fill: fill, d: "M7.99982089 4.55043164l4.94974747 4.94974747-1.41421356 1.41421356-3.5355339-3.53553391-3.5355339 3.5355339L3.05007343 9.5001791l4.94974746-4.94974746z" })));
      case 'warning':
        return (h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16" }, h("path", { fill: fill, d: "M8.49613894 2.1473213c.15503128.0885893.2835149.21707292.3721042.3721042l6.27682036 10.9844356c.2740099.4795174.1074132 1.0903721-.3721042 1.364382-.1510977.0863416-.322112.1317569-.496139.1317569H1.72317968c-.55228475 0-1-.4477153-1-1 0-.1740269.04541532-.3450412.13175686-.4961389L7.13175686 2.5194255c.27400997-.47951745.88486463-.64611418 1.36438208-.3721042zM9 11H7v2h2v-2zm.5-5.5h-3l.7610545 4.5h1.49397234L9.5 5.5z" })));
    }
  }
  render() {
    return h(Host, null, this.getIconSVG());
  }
};
CmIcon.style = cmIconCss;

const cmIconButtonCss = ":host{display:inline-grid;user-select:none}div{display:grid;position:relative;transition:all 0.2s linear;height:20px;width:20px;cursor:pointer;z-index:1}div cm-icon{align-self:center;justify-self:center}div.disabled{pointer-events:none;cursor:default;opacity:0.5}div::before{content:\"\";position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);height:32px;width:32px;border-radius:100%;background-color:rgba(var(--cm-color-ui-light5-rgb), 0);transition:all 0.2s linear;z-index:-1}div:focus{outline:none}div:hover::before{background-color:rgba(var(--cm-color-ui-light5-rgb), 0.5)}div:focus-visible::before{background-color:rgba(var(--cm-color-ui-light5-rgb), 0.5);box-shadow:0px 0px 0px 1px var(--cm-color-focus-inner-neutral2), 0px 0px 0px 4px var(--cm-color-focus-outer-neutral)}div:active::before{background-color:rgba(var(--cm-color-ui-light5-rgb), 1)}";

const CmIconButton = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.cmPress = createEvent(this, "cmPress", 7);
    this.disabled = false;
    this.ignoreTheme = false;
  }
  /**
   * Triggers the press event. Respects the disabled state unless forced.
   */
  async press(options = {}) {
    if (!this.disabled || options.forcePress) {
      this.cmPress.emit();
    }
  }
  handleClick() {
    if (!this.disabled) {
      this.press();
    }
  }
  handleKeyDown(event) {
    if (event.key === ' ' || event.key === 'Enter') {
      if (!this.disabled) {
        this.press();
      }
    }
  }
  render() {
    let classes = {
      disabled: this.disabled,
    };
    let tabIndex = 0;
    if (this.disabled) {
      tabIndex = -1;
    }
    return (h(Host, null, h("div", { tabindex: tabIndex, class: classes, role: "button", "aria-disabled": this.disabled, "aria-label": this.icon }, h("cm-icon", { icon: this.icon, ignoreTheme: this.ignoreTheme }))));
  }
  get el() { return getElement(this); }
};
CmIconButton.style = cmIconButtonCss;

const cmLinkCss = ":host{display:inline}a{font-family:var(--cm-font-text);font-size:14px;font-weight:400;border-radius:3px;text-decoration:none;color:var(--cm-color-link)}a::after{content:\"\";display:inline-block;padding-left:5px;width:12px;height:12px;background-image:url(\"data:image/svg+xml,%3Csvg width='12px' height='12px' viewBox='0 0 12 12' version='1.1' xmlns='http://www.w3.org/2000/svg' %3E%3Cg stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' %3E%3Cpath d='M6,0 L6,1.4 L1.4,1.4 L1.4,10.6 L10.6,10.6 L10.6,6.485 L12,6.485 L12,12 L0,12 L0,0 L6,0 Z M12,0 L12,5.204 L10.203,3.205 L6.707,6.702 L5.293,5.288 L8.863,1.716 L7.32,0 L12,0 Z' fill='%23346ac5' fill-rule='nonzero' %3E%3C/path%3E%3C/g%3E%3C/svg%3E\");background-position:right;background-repeat:no-repeat;transform:translateY(1px)}a:hover{color:var(--cm-color-link-hover)}a:focus{outline:none}a:focus-visible{box-shadow:0px 0px 0px 1px var(--cm-color-focus-inner-neutral), 0px 0px 0px 4px var(--cm-color-focus-outer-neutral)}a:active{color:var(--cm-color-link-active)}a.Dark{color:var(--cm-color-link-dark)}a.Dark:hover{color:var(--cm-color-link-hover-dark)}a.Dark:active{color:var(--cm-color-link-active-dark)}";

const CmLink = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.href = '';
    this.label = '';
    this.openIn = 'newTab';
    this.theme = 'Light';
  }
  componentWillLoad() {
    onThemeChange((theme) => {
      this.theme = theme;
    });
  }
  render() {
    let classes = {
      [this.theme]: true,
    };
    let target = '';
    if (this.openIn === 'newTab') {
      target = '_blank';
    }
    return (h(Host, null, h("a", { class: classes, target: target, href: this.href }, this.label)));
  }
};
CmLink.style = cmLinkCss;

const cmLoaderCss = "@keyframes spinner{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}:host{display:inline-block}.spinner{box-sizing:content-box;border-radius:50%;border-style:solid}.spinner.normal{width:22px;height:22px;animation:spinner 0.8s linear infinite;border-width:4px}.spinner.small{width:10px;height:10px;border-width:2px;animation:spinner 0.7s linear infinite}.spinner.dark{border-color:var(--cm-color-ui-light6);border-bottom-color:transparent}.spinner.light{border-color:var(--cm-color-ui-light4);border-bottom-color:transparent}";

const CmLoader = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.size = 'normal';
    this.color = 'dark';
  }
  render() {
    let classes = {
      spinner: true,
      [this.size]: true,
      [this.color]: true,
    };
    return (h(Host, null, h("div", { class: classes })));
  }
};
CmLoader.style = cmLoaderCss;

const cmLogoCss = ":host{display:inline-block}.logo{width:26px;height:26px;background-image:url(\"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg version='1.1' viewBox='0 0 26 26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%2362626E' fill-rule='nonzero'%3E%3Cpath d='m13 0c7.1797 0 13 5.8203 13 13 0 7.1797-5.8203 13-13 13-7.1797 0-13-5.8203-13-13 0-7.1797 5.8203-13 13-13zm2.9925 18.778h-5.9993v3.3902h5.9993v-3.3902zm-2.9925-14.946c-1.9751 0-2.9942 1.1645-3.0068 3.2128v6.6476l0.0036413 0.20697c0.067943 1.9028 1.0859 2.9915 2.9889 2.9915 1.9751 0 2.9917-1.1645 3.0068-3.2128v-1.6951h-1.9011v1.8271l-0.0046341 0.16453c-0.04616 0.78875-0.43443 1.074-1.0422 1.074-0.63398 0-1.0468-0.32456-1.0468-1.2385v-6.9158l0.0046342-0.16485c0.04616-0.79193 0.43443-1.1022 1.0422-1.088 0.63398 0 1.0468 0.35399 1.0468 1.268v1.3705h1.9011v-1.2352l-0.0036268-0.20872c-0.067677-1.9185-1.0819-3.0041-2.9889-3.0041z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A\")}";

const CmLogo = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  render() {
    return (h(Host, null, h("div", { class: "logo" })));
  }
};
CmLogo.style = cmLogoCss;

const cmModalCss = ":host{display:block;position:fixed;z-index:1000}.container{display:grid;justify-content:center;position:fixed;top:0px;left:0px;right:0px;bottom:0px;background-color:rgba(0, 0, 0, 0.5);padding:110px 0px 60px;opacity:0;pointer-events:none;transition:all 0.2s linear}.container.open{opacity:1;pointer-events:unset}.container.open .window{transform:scale(1)}.container.center{align-items:center;padding-bottom:140px}.container.center .window{max-height:calc( \t\t\t\t100vh - 110px - 140px \t\t\t)}.container.top{align-items:flex-start}.window{display:grid;box-sizing:border-box;width:636px;max-height:calc( \t\t100vh - 110px - 60px \t);box-shadow:0 2px 2px 0 rgba(0, 0, 0, 0.5);border-radius:3px;overflow:hidden;border:solid 1px var(--cm-color-ui-light5);background-color:var(--cm-color-ui-light4);grid-template:\"header\" 57px \"content\" minmax(0, 1fr) \"buttons\" 65px;transform:scale(0.9);transition:all 0.2s linear}.window .header{display:grid;grid-area:header;box-sizing:border-box;padding:0px 20px;border-bottom:solid 1px var(--cm-color-ui-light5);background-color:var(--cm-color-ui-light2);align-items:center;grid-auto-flow:column}.window .header h1{justify-self:start;font-family:var(--cm-font-text);font-size:15px;font-weight:bold;color:var(--cm-color-ui-light6)}.window .header cm-icon-button{justify-self:end}.window .content{grid-area:content;box-sizing:border-box;padding:20px;overflow:auto}.window .buttons{display:grid;grid-area:buttons;box-sizing:border-box;border-top:solid 1px var(--cm-color-ui-light5);padding:0px 20px;gap:15px;justify-content:end;align-items:center;grid-auto-flow:column}";

const CmModal = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.isOpen = false;
    this.confirmLoading = false;
    this.cancelDisabled = false;
    this.position = 'center';
    this.headline = '';
    this.confirmLabel = '';
    this.confirmAppearance = 'primary';
    this.confirmDisabled = false;
    this.cancelLabel = '';
    this.cancelAppearance = 'secondary';
  }
  handleKeyDown(event) {
    if (event.key === 'Escape') {
      this.cancel();
    }
  }
  /**
   * Opens the modal. Takes an optional handler for asynchronous confirm actions, which only trigger confirm if the returned Promise resolves successfully. While the Promise is unresolved, the Modal stays open and the ConfirmButton is in a loading state.
   */
  async open(preConfirmationHandler) {
    this.preConfirmationHandler = preConfirmationHandler;
    this.promise = new Promise((resolve) => {
      this.promiseResolver = resolve;
    });
    this.isOpen = true;
    this.el.focus();
    return this.promise;
  }
  /**
   * Triggers the 'confirm' action on the modal, if it is open.
   */
  async confirm() {
    if (this.isOpen) {
      if (this.preConfirmationHandler) {
        this.confirmLoading = true;
        this.cancelDisabled = true;
        this.preConfirmationHandler().then(() => {
          this.isOpen = false;
          this.promiseResolver('confirm');
          this.confirmLoading = false;
          this.cancelDisabled = false;
        }, () => {
          this.confirmLoading = false;
          this.cancelDisabled = false;
        });
      }
      else {
        this.isOpen = false;
        this.promiseResolver('confirm');
      }
    }
    return this.promise;
  }
  /**
   * Triggers the 'cancel' action on the modal, if it is open.
   */
  async cancel() {
    if (this.isOpen) {
      this.isOpen = false;
      this.promiseResolver('cancel');
    }
    return this.promise;
  }
  render() {
    let classes = {
      container: true,
      open: this.isOpen,
      [this.position]: true,
    };
    return (h(Host, { tabindex: "0" }, h("div", { class: classes }, h("div", { class: "window" }, h("div", { class: "header" }, h("h1", null, this.headline), h("cm-icon-button", { disabled: this.cancelDisabled, icon: "closeLarge", onCmPress: () => this.cancel() })), h("div", { class: "content" }, h("slot", null)), h("div", { class: "buttons" }, this.cancelLabel !== '' ? (h("cm-button", { disabled: this.cancelDisabled, appearance: this.cancelAppearance, label: this.cancelLabel, onCmPress: () => this.cancel() })) : (''), h("cm-button", { appearance: this.confirmAppearance, label: this.confirmLabel, loading: this.confirmLoading, disabled: this.confirmDisabled, onCmPress: () => this.confirm() }))))));
  }
  get el() { return getElement(this); }
};
CmModal.style = cmModalCss;

const cmNotificationCss = ":host{display:block;box-sizing:border-box}.shadowContainer{padding:10px}.container{display:grid;box-sizing:border-box;position:relative;grid-template-areas:\"icon content content content closeButton\";grid-template-columns:24px 1fr 1fr 70px 20px;grid-template-rows:max-content;column-gap:10px;row-gap:10px;align-items:center;background-color:var(--cm-color-ui-light1);font-family:var(--cm-font-text);color:rgba(var(--cm-color-ui-dark4-rgb), 0.9);padding:16px 16px 12px;width:330px;border-radius:5px;box-shadow:0 0.1px 0.3px rgba(var(--cm-color-black-base-rgb), 0.042), 0 0.1px 0.7px rgba(var(--cm-color-black-base-rgb), 0.061), 0 0.3px 1.3px rgba(var(--cm-color-black-base-rgb), 0.075), 0 0.4px 2.2px rgba(var(--cm-color-black-base-rgb), 0.089), 0 0.8px 4.2px rgba(var(--cm-color-black-base-rgb), 0.108), 0 2px 10px rgba(var(--cm-color-black-base-rgb), 0.15)}.container.hasTimeOrNavigationLabel{grid-template-areas:\"icon content         content         content closeButton\" \".    navigationLabel navigationLabel date    date\";grid-template-columns:24px 1fr 1fr 70px 20px;grid-template-rows:max-content max-content}.container.Dark{background-color:var(--cm-color-ui-dark5);color:var(--cm-color-white-base)}.container.Dark .content{color:var(--cm-color-white-base)}.container.Dark .icon.info{background-image:url('data:image/svg+xml,%3Csvg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"%3E%3Cdefs%3E%3Cfilter id=\"jer5mdwwsa\" width=\"105.3%25\" height=\"131.5%25\" x=\"-2.7%25\" y=\"-12%25\" filterUnits=\"objectBoundingBox\"%3E%3CfeOffset dy=\"2\" in=\"SourceAlpha\" result=\"shadowOffsetOuter1\"/%3E%3CfeGaussianBlur in=\"shadowOffsetOuter1\" result=\"shadowBlurOuter1\" stdDeviation=\"2.5\"/%3E%3CfeColorMatrix in=\"shadowBlurOuter1\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0\"/%3E%3C/filter%3E%3Crect id=\"su7xbi42qb\" width=\"320\" height=\"54\" x=\"0\" y=\"0\" rx=\"3\"/%3E%3C/defs%3E%3Cg fill=\"none\" fill-rule=\"evenodd\"%3E%3Cpath fill=\"%23FFF\" d=\"M0 0H1597V1178H0z\" transform=\"translate(-543 -440)\"/%3E%3Cg%3E%3Cg%3E%3Cg%3E%3Cg fill-rule=\"nonzero\"%3E%3Cg transform=\"translate(-543 -440) translate(528 425)\"%3E%3Cuse fill=\"%23000\" filter=\"url(%23jer5mdwwsa)\" xlink:href=\"%23su7xbi42qb\"/%3E%3Cuse fill=\"%235B5E63\" xlink:href=\"%23su7xbi42qb\"/%3E%3C/g%3E%3C/g%3E%3Cg transform=\"translate(-543 -440) translate(528 425) translate(15 15)\"%3E%3Ccircle cx=\"12\" cy=\"12\" r=\"11\" fill=\"%23FFF\" fill-opacity=\".9\"/%3E%3Cpath fill=\"%235B5E63\" d=\"M13.77 10.9v5.5h.73v1.1h-5v-1.1h.808V12h-.77v-1.1h4.231zm-1.8-4.4c.954 0 1.73.74 1.73 1.65 0 .91-.776 1.65-1.73 1.65-.955 0-1.732-.74-1.732-1.65 0-.91.777-1.65 1.731-1.65z\"/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A')}.container.Dark .icon.success{background-image:url('data:image/svg+xml,%3Csvg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"%3E%3Cdefs%3E%3Cfilter id=\"x6tau83poa\" width=\"105.3%25\" height=\"131.5%25\" x=\"-2.7%25\" y=\"-12%25\" filterUnits=\"objectBoundingBox\"%3E%3CfeOffset dy=\"2\" in=\"SourceAlpha\" result=\"shadowOffsetOuter1\"/%3E%3CfeGaussianBlur in=\"shadowOffsetOuter1\" result=\"shadowBlurOuter1\" stdDeviation=\"2.5\"/%3E%3CfeColorMatrix in=\"shadowBlurOuter1\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0\"/%3E%3C/filter%3E%3Crect id=\"lxzdrfgayb\" width=\"320\" height=\"54\" x=\"0\" y=\"0\" rx=\"3\"/%3E%3C/defs%3E%3Cg fill=\"none\" fill-rule=\"evenodd\"%3E%3Cpath fill=\"%23FFF\" d=\"M0 0H1597V1178H0z\" transform=\"translate(-543 -312)\"/%3E%3Cg%3E%3Cg%3E%3Cg%3E%3Cg fill-rule=\"nonzero\"%3E%3Cg transform=\"translate(-543 -312) translate(528 297)\"%3E%3Cuse fill=\"%23000\" filter=\"url(%23x6tau83poa)\" xlink:href=\"%23lxzdrfgayb\"/%3E%3Cuse fill=\"%235B5E63\" xlink:href=\"%23lxzdrfgayb\"/%3E%3C/g%3E%3C/g%3E%3Cg transform=\"translate(-543 -312) translate(528 297) translate(15 15)\"%3E%3Ccircle cx=\"12\" cy=\"12\" r=\"11\" fill=\"%2310D070\"/%3E%3Cpath fill=\"%23FFF\" d=\"M9.743 18.314L5 13.57 6.897 11.673 9.743 14.519 17.103 7.16 19 9.057z\"/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A')}.container.Dark .icon.error{background-image:url('data:image/svg+xml,%3Csvg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"%3E%3Cdefs%3E%3Cfilter id=\"6isxl983ca\" width=\"105.3%25\" height=\"131.5%25\" x=\"-2.7%25\" y=\"-12%25\" filterUnits=\"objectBoundingBox\"%3E%3CfeOffset dy=\"2\" in=\"SourceAlpha\" result=\"shadowOffsetOuter1\"/%3E%3CfeGaussianBlur in=\"shadowOffsetOuter1\" result=\"shadowBlurOuter1\" stdDeviation=\"2.5\"/%3E%3CfeColorMatrix in=\"shadowBlurOuter1\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0\"/%3E%3C/filter%3E%3Crect id=\"54e4un39nb\" width=\"320\" height=\"54\" x=\"0\" y=\"0\" rx=\"3\"/%3E%3C/defs%3E%3Cg fill=\"none\" fill-rule=\"evenodd\"%3E%3Cpath fill=\"%23FFF\" d=\"M0 0H1597V1178H0z\" transform=\"translate(-543 -192)\"/%3E%3Cg%3E%3Cg%3E%3Cg%3E%3Cg fill-rule=\"nonzero\"%3E%3Cg transform=\"translate(-543 -192) translate(528 177)\"%3E%3Cuse fill=\"%23000\" filter=\"url(%236isxl983ca)\" xlink:href=\"%2354e4un39nb\"/%3E%3Cuse fill=\"%235B5E63\" xlink:href=\"%2354e4un39nb\"/%3E%3C/g%3E%3C/g%3E%3Cg transform=\"translate(-543 -192) translate(528 177) translate(15 15)\"%3E%3Ccircle cx=\"12\" cy=\"12\" r=\"11\" fill=\"%23FF3D3D\"/%3E%3Cpath fill=\"%23FFF\" d=\"M13 5v6h6v2h-6v6h-2v-6H5v-2h6V5h2z\" transform=\"rotate(45 12 12)\"/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A')}.container.Dark .date{color:rgba(var(--cm-color-white-base-rgb), 0.4)}.container .icon{grid-area:icon;width:24px;height:24px;align-self:flex-start}.container .icon.info{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='24' height='24'%3E%3Cdefs%3E%3Cfilter id='a' width='105.3%25' height='131.5%25' x='-2.7%25' y='-12%25' filterUnits='objectBoundingBox'%3E%3CfeOffset dy='2' in='SourceAlpha' result='shadowOffsetOuter1'/%3E%3CfeGaussianBlur in='shadowOffsetOuter1' result='shadowBlurOuter1' stdDeviation='2.5'/%3E%3CfeColorMatrix in='shadowBlurOuter1' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0'/%3E%3C/filter%3E%3Crect id='b' width='320' height='54' x='0' y='0' rx='3'/%3E%3C/defs%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath fill='%23FFF' d='M-73-437h1597V741H-73z'/%3E%3Cg transform='translate(-15 -15)' fill-rule='nonzero'%3E%3Cuse fill='%23000' filter='url(%23a)' xlink:href='%23b'/%3E%3Cuse fill='%23F2F3F5' xlink:href='%23b'/%3E%3C/g%3E%3Cg%3E%3Ccircle cx='12' cy='12' r='11' fill='%2362626E'/%3E%3Cpath fill='%23FFF' d='M13.77 10.9v5.5h.73v1.1h-5v-1.1h.808V12h-.77v-1.1h4.231zm-1.8-4.4c.954 0 1.73.74 1.73 1.65 0 .91-.776 1.65-1.73 1.65-.955 0-1.732-.74-1.732-1.65 0-.91.777-1.65 1.731-1.65z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\")}.container .icon.error{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='24' height='24'%3E%3Cdefs%3E%3Cfilter id='a' width='105.3%25' height='131.5%25' x='-2.7%25' y='-12%25' filterUnits='objectBoundingBox'%3E%3CfeOffset dy='2' in='SourceAlpha' result='shadowOffsetOuter1'/%3E%3CfeGaussianBlur in='shadowOffsetOuter1' result='shadowBlurOuter1' stdDeviation='2.5'/%3E%3CfeColorMatrix in='shadowBlurOuter1' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0'/%3E%3C/filter%3E%3Crect id='b' width='320' height='54' x='0' y='0' rx='3'/%3E%3C/defs%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath fill='%23FFF' d='M-73-192h1597V986H-73z'/%3E%3Cg transform='translate(-15 -15)' fill-rule='nonzero'%3E%3Cuse fill='%23000' filter='url(%23a)' xlink:href='%23b'/%3E%3Cuse fill='%23F2F3F5' xlink:href='%23b'/%3E%3C/g%3E%3Cg%3E%3Ccircle cx='12' cy='12' r='11' fill='%23FF3D3D'/%3E%3Cpath fill='%23FFF' d='M17.657 7.757L13.414 12l4.243 4.243-1.414 1.414L12 13.414l-4.243 4.243-1.414-1.414L10.586 12 6.343 7.757l1.414-1.414L12 10.586l4.243-4.243 1.414 1.414z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\")}.container .icon.success{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='24' height='24'%3E%3Cdefs%3E%3Cfilter id='a' width='105.3%25' height='131.5%25' x='-2.7%25' y='-12%25' filterUnits='objectBoundingBox'%3E%3CfeOffset dy='2' in='SourceAlpha' result='shadowOffsetOuter1'/%3E%3CfeGaussianBlur in='shadowOffsetOuter1' result='shadowBlurOuter1' stdDeviation='2.5'/%3E%3CfeColorMatrix in='shadowBlurOuter1' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0'/%3E%3C/filter%3E%3Crect id='b' width='320' height='54' x='0' y='0' rx='3'/%3E%3C/defs%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath fill='%23FFF' d='M-73-315h1597V863H-73z'/%3E%3Cg transform='translate(-15 -15)' fill-rule='nonzero'%3E%3Cuse fill='%23000' filter='url(%23a)' xlink:href='%23b'/%3E%3Cuse fill='%23F2F3F5' xlink:href='%23b'/%3E%3C/g%3E%3Cg%3E%3Ccircle cx='12' cy='12' r='11' fill='%2310D070'/%3E%3Cpath fill='%23FFF' d='M9.743 18.314L5 13.57l1.897-1.897 2.846 2.846 7.36-7.359L19 9.057z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\")}.container .content{grid-area:content;display:grid;grid-auto-flow:row;gap:4px;padding-top:2px}.container .content .headline{font-size:15px;font-weight:500;overflow-wrap:anywhere}.container .content .description{font-size:13px;overflow-wrap:anywhere}.container cm-icon-button{display:none;grid-area:closeButton;align-self:flex-start;transform:translateY(2px)}.container.isUserDismissable cm-icon-button{display:unset}.container .date{grid-area:date;font-size:13px;justify-self:flex-end;color:rgba(var(--cm-color-black-base-rgb), 0.4)}.container cm-button{grid-area:navigationLabel;justify-self:flex-start}";

const CmNotification = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.cmDismissed = createEvent(this, "cmDismissed", 7);
    this.cmNotificationNavigation = createEvent(this, "cmNotificationNavigation", 7);
    this.didLoad = createEvent(this, "didLoad", 7);
    this.appearance = 'info';
    this.description = '';
    this.navigationLabel = '';
    this.userDismissable = true;
    this.showCreationTime = true;
    this.elapsedTime = 0;
    this.theme = 'Light';
    this._isBeingHovered = false;
  }
  /**
   * Dismisses the Notification.
   */
  async dismiss() {
    this.cmDismissed.emit();
  }
  /**
   * Returns the hover state. This is being used to halt Notification-Timeouts.
   */
  async isBeingHovered() {
    return this._isBeingHovered;
  }
  componentWillLoad() {
    onThemeChange((theme) => {
      this.theme = theme;
    });
  }
  componentDidLoad() {
    this.el.addEventListener('mouseenter', () => {
      this._isBeingHovered = true;
    });
    this.el.addEventListener('mouseleave', () => {
      this._isBeingHovered = false;
    });
    this.timer = setInterval(() => {
      this.elapsedTime += 1;
    }, 1000);
    this.didLoad.emit(); // Necessary for the notification container to access the correct clientHeight
  }
  disconnectedCallback() {
    clearInterval(this.timer);
  }
  render() {
    let containerClasses = {
      container: true,
      [this.theme]: true,
      isUserDismissable: this.userDismissable,
      hasDescription: this.description.length !== 0,
      hasTimeOrNavigationLabel: Boolean(this.showCreationTime || this.navigationLabel),
    };
    let iconClasses = {
      icon: true,
      [this.appearance]: true,
    };
    let timeDifferential = -Math.trunc(Math.abs(this.createdAt - Date.now()) / 1000);
    let timeDifferentialUnit;
    if (timeDifferential > -60) {
      timeDifferentialUnit = 'seconds';
    }
    else {
      timeDifferential = -Math.trunc(Math.abs(timeDifferential) / 60);
      timeDifferentialUnit = 'minutes';
    }
    return (h(Host, null, h("div", { class: "shadowContainer" }, h("div", { class: containerClasses, role: "alert" }, h("div", { class: iconClasses }), h("div", { class: "content" }, h("div", { class: "headline" }, this.headline), h("div", { class: "description" }, this.description)), this.userDismissable ? (h("cm-icon-button", { icon: 'close', onCmPress: () => this.dismiss() })) : (''), this.showCreationTime ? (h("div", { class: "date" }, timeDifferential > -10 &&
      timeDifferentialUnit == 'seconds'
      ? 'Just now'
      : new Intl.RelativeTimeFormat('en', {
        localeMatcher: 'best fit',
        numeric: 'always',
        style: 'long',
      }).format(timeDifferential, timeDifferentialUnit))) : (''), this.navigationLabel ? (h("cm-button", { appearance: "link", label: this.navigationLabel, onCmPress: () => {
        this.cmNotificationNavigation.emit({});
        this.dismiss();
      } })) : ('')))));
  }
  get el() { return getElement(this); }
};
CmNotification.style = cmNotificationCss;

const cmNotificationContainerCss = ":host{display:block;overflow:hidden}#notificationContainer{display:grid;position:relative;grid-auto-flow:dense;align-content:end;width:350px;overflow:hidden}#notificationContainer cm-notification.hidden{position:absolute;bottom:1000px;z-index:-1}#notificationContainer cm-notification.collapse{height:0;padding:0}";

const CmNotificationContainer = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.notificationQueue = [];
    this.notificationMap = new Map();
    this.visibleNotifications = [];
    this.durationStore = new Map();
    this.maxVisibleNotifications = 5;
    this.notificationDuration = 7000;
  }
  /**
   * Queues a Notification to be shown. The notification might be shown instantly, if there is space, or later, once space is available.
   */
  async enqueueNotification(notification) {
    let completeNotification = Object.assign(Object.assign({}, notification), { createdAt: Date.now() });
    if (this.maxVisibleNotifications <= this.visibleNotifications.length) {
      this.notificationQueue.push(completeNotification);
    }
    else {
      this.renderNewNotification(completeNotification);
    }
    return {
      hasBeenShown: () => {
        return !this.notificationQueue.includes(completeNotification);
      },
      remove: () => {
        if (this.notificationQueue.includes(completeNotification)) {
          this.notificationQueue = this.notificationQueue.filter((item) => item !== completeNotification);
        }
        else {
          let notificationElement = this.notificationMap.get(completeNotification);
          if (notificationElement) {
            notificationElement.dismiss();
          }
        }
      },
    };
  }
  componentDidLoad() {
    setInterval(() => {
      this.countTimerDown(100);
    }, 100);
  }
  async countTimerDown(expiredTime) {
    let entries = Array.from(this.durationStore.entries());
    for (let [key, value] of entries) {
      if (!document.hidden && !(await key.isBeingHovered())) {
        let newValue = value - expiredTime;
        if (newValue <= 0) {
          this.durationStore.delete(key);
          key.dismiss();
        }
        this.durationStore.set(key, newValue);
      }
    }
  }
  renderNewNotification(notification) {
    var _a;
    let notificationContainer = this.el.shadowRoot.querySelector('#notificationContainer');
    let newNotification = document.createElement('cm-notification');
    this.notificationMap.set(notification, newNotification);
    newNotification.headline = notification.headline;
    newNotification.description = notification.description;
    newNotification.appearance = notification.appearance;
    newNotification.userDismissable = notification.userDismissable;
    newNotification.showCreationTime = notification.showCreationTime;
    newNotification.createdAt = notification.createdAt;
    if (notification.navigation != null) {
      newNotification.navigationLabel = notification.navigation.label;
      newNotification.addEventListener('cmNotificationNavigation', notification.navigation.navigationHandler);
    }
    if (newNotification.userDismissable ||
      newNotification.userDismissable == null) {
      this.durationStore.set(newNotification, (_a = notification.duration) !== null && _a !== void 0 ? _a : this.notificationDuration);
    }
    newNotification.classList.add('hidden');
    notificationContainer.appendChild(newNotification);
    this.visibleNotifications.push(newNotification);
    newNotification.addEventListener('didLoad', () => {
      newNotification.classList.remove('hidden');
      notificationContainer.animate([
        {
          transform: `translateY(${newNotification.clientHeight}px)`,
        },
        { transform: 'translateY(0%)' },
      ], { duration: 150, easing: 'linear' });
    });
    newNotification.addEventListener('cmDismissed', () => {
      this.durationStore.delete(newNotification);
      requestAnimationFrame(() => {
        newNotification
          .animate([
          { height: `${newNotification.clientHeight}px` },
          {
            opacity: 0,
            height: 0,
            padding: 0,
          },
        ], { duration: 150, easing: 'linear' })
          .addEventListener('finish', () => {
          this.notificationMap.delete(notification);
          this.visibleNotifications =
            this.visibleNotifications.filter((item) => item !== newNotification);
          newNotification.remove();
          if (this.notificationQueue.length) {
            setTimeout(() => {
              requestAnimationFrame(() => {
                this.renderNewNotification(this.notificationQueue.shift());
              });
            }, 200);
          }
        });
      });
    });
  }
  render() {
    return (h(Host, { "aria-live": "polite" }, h("div", { id: "notificationContainer" })));
  }
  get el() { return getElement(this); }
};
CmNotificationContainer.style = cmNotificationContainerCss;

const cmPageCss = ":host{display:flex;flex-direction:column;background:var(--cm-color-ui-light4)}header{background:var(--cm-color-ui-light1);padding:0px 65px;border-bottom:1px solid var(--cm-color-ui-light5)}header.empty{border-bottom:0px;height:0px;display:none}header .handles{display:flex;width:100%;position:relative;top:1px;left:-8px;height:30px;flex-direction:row}header .handles.empty{height:0px}header .handles cm-page-tab-handle:not(:last-child){margin-right:20px}header .handles cm-page-tab-handle:nth-child(1):last-child{display:none}header .headerSlot{height:105px;display:grid;grid-auto-flow:column;grid-auto-columns:max-content;gap:10px;align-content:center}.tabs{height:100%;overflow:hidden;background-color:var(--cm-color-ui-light2)}";

const CmPage = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.tabChanged = createEvent(this, "tabChanged", 7);
    this.isHeaderEmpty = true;
    this.tabRefs = [];
    this.labelToTabMap = {};
    this.labelToHandleMap = {};
    this.labels = [];
  }
  activeTitleWatchHandler(newValue, oldValue) {
    this.parseTabList();
    if (!this.labels.includes(newValue)) {
      console.error(`Active label not found! Refusing to update. Requested activeLabel: '${newValue}' Old activeLabel: '${oldValue}' All labels: '${this.labels}'`);
      if (!this.labels.includes(oldValue)) {
        console.error(`Old label is not there anymore. Refusing to revert. Requested activeLabel: '${newValue}' Old activeLabel: '${oldValue}' All labels: '${this.labels}'`);
      }
      else {
        this.activeLabel = oldValue;
      }
    }
    else {
      this.tabChanged.emit({
        label: newValue,
        tab: this.labelToTabMap[newValue],
        handle: this.labelToHandleMap[newValue],
      });
    }
  }
  tabModifiedEventHandler() {
    this.parseTabList();
  }
  userSelectedTabHandler(event) {
    const label = event.detail.label;
    this.switchToTab(label);
  }
  /**
   * Returns the currently active tab, handle, and title.
   */
  async getActiveState() {
    return {
      label: this.activeLabel,
      tab: this.labelToTabMap[this.activeLabel],
      handle: this.labelToHandleMap[this.activeLabel],
    };
  }
  /**
   * Switches to a tab based on their label.
   * @param label Title of the target tab.
   */
  async switchToTab(label) {
    this.activeLabel = label;
  }
  /**
   * Switches to a tab based on their index.
   * @param index Index of the target tab.
   */
  async switchToTabIndex(index) {
    const label = this.labels[index];
    return this.switchToTab(label);
  }
  onChildrenChange() {
    this.parseTabList();
  }
  parseTabList() {
    this.tabRefs = Array.from(this.root.querySelectorAll('cm-page-tab'));
    this.labels = this.tabRefs.map((tabRef) => tabRef.label);
    this.labelToTabMap = {};
    this.tabRefs.forEach((tabRef) => {
      this.labelToTabMap[tabRef.label] = tabRef;
    });
  }
  componentDidRender() {
    requestAnimationFrame(() => {
      let headerSlot = this.root.shadowRoot.querySelector('slot[name=header]');
      if (headerSlot) {
        this.isHeaderEmpty = headerSlot.assignedElements().length === 0;
      }
    });
  }
  componentDidLoad() {
    const observer = new MutationObserver(this.onChildrenChange.bind(this));
    const options = {
      childList: true,
    };
    observer.observe(this.root, options);
    let headerSlot = this.root.shadowRoot.querySelector('slot[name=header]');
    headerSlot.addEventListener('slotchange', () => {
      this.isHeaderEmpty = headerSlot.assignedElements().length === 0;
    });
  }
  async componentWillRender() {
    this.parseTabList();
    if (!this.labels.includes(this.activeLabel) && this.labels.length > 0) {
      await this.switchToTabIndex(0);
    }
    this.tabRefs.forEach((tabRef) => {
      tabRef.active = false;
    });
    if (this.labelToTabMap.hasOwnProperty(this.activeLabel)) {
      this.labelToTabMap[this.activeLabel].active = true;
    }
    this.labelToHandleMap = {};
  }
  render() {
    let handlesClasses = { handles: true, empty: this.tabRefs.length < 2 };
    let headerClasses = {
      empty: this.isHeaderEmpty && handlesClasses.empty,
    };
    return (h(Host, null, h("header", { class: headerClasses }, h("div", { class: "headerSlot" }, h("slot", { name: "header" })), h("div", { class: handlesClasses }, this.tabRefs.map((tab) => {
      return (h("cm-page-tab-handle", { key: tab.label, label: tab.label, active: this.activeLabel === tab.label, ref: (elem) => (this.labelToHandleMap[tab.label] =
          elem) }));
    }))), h("div", { class: "tabs" }, h("slot", null))));
  }
  get root() { return getElement(this); }
  static get watchers() { return {
    "activeLabel": ["activeTitleWatchHandler"]
  }; }
};
CmPage.style = cmPageCss;

const cmPageTabCss = ":host{display:none;padding:40px 65px 0px}:host([active]){display:grid;height:100%;overflow:hidden}";

const CmPageTab = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.tabModified = createEvent(this, "tabModified", 7);
    this.defaultActive = false;
    this.active = this.defaultActive;
  }
  labelWatchHandler() {
    this.tabModified.emit();
  }
  activeWatchHandler(newValue) {
    if (newValue === null || newValue === undefined) {
      this.active = this.defaultActive;
    }
  }
  componentWillRender() {
    this.activeWatchHandler(this.active);
  }
  render() {
    return (h(Host, { role: "tabpanel", id: this.label, "aria-expanded": this.active, "aria-hidden": !this.active }, h("slot", null)));
  }
  get root() { return getElement(this); }
  static get watchers() { return {
    "label": ["labelWatchHandler"],
    "active": ["activeWatchHandler"]
  }; }
};
CmPageTab.style = cmPageTabCss;

const cmPageTabHandleCss = "span{display:grid;position:relative;cursor:pointer;box-sizing:border-box;height:30px;font-family:var(--cm-font-text);font-size:15px;text-align:center;align-content:center;color:var(--cm-color-ui-light6);padding:4px 8px;border-bottom:2px solid transparent;transition:0.2s all linear;white-space:nowrap}span:hover{border-bottom:2px solid rgba(var(--cm-color-ui-light6-rgb), 0.6)}span:focus{outline:none}span:focus-visible{border-radius:3px;box-shadow:0px 0px 0px 1px var(--cm-color-focus-inner-neutral2), 0px 0px 0px 4px var(--cm-color-focus-outer-neutral)}span::after{content:attr(data-label);display:grid;transition:0.2s all linear;position:absolute;top:0px;bottom:0px;left:0%;right:0%;align-content:center;color:var(--cm-color-ui-dark4);font-weight:500;opacity:0}span.active{color:transparent;pointer-events:none;cursor:default;transition:0.2s all linear;border-bottom:2px solid var(--cm-color-ui-dark4)}span.active::after{opacity:1}";

const CmPageTabHandle = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.userSelectedTab = createEvent(this, "userSelectedTab", 7);
    this.defaultActive = false;
    this.active = this.defaultActive;
  }
  activeWatchHandler(newValue) {
    if (newValue === null || newValue === undefined) {
      this.active = this.defaultActive;
    }
  }
  clickEventHandler(event) {
    this.userSelectedTab.emit({
      originalEvent: event,
      handle: this.root,
      label: this.label,
    });
  }
  handleKeyDown(event) {
    if (event.key === ' ' || event.key === 'Enter') {
      this.userSelectedTab.emit({
        originalEvent: event,
        handle: this.root,
        label: this.label,
      });
    }
  }
  componentWillRender() {
    this.activeWatchHandler(this.active);
  }
  render() {
    let classes = { active: this.active };
    return (h(Host, null, h("span", { class: classes, "data-label": this.label, ref: (element) => (this.span = element), tabindex: "0", role: "tab", "aria-controls": this.label, "aria-selected": this.active }, this.label)));
  }
  get root() { return getElement(this); }
  static get watchers() { return {
    "active": ["activeWatchHandler"]
  }; }
};
CmPageTabHandle.style = cmPageTabHandleCss;

const cmSelectCss = "div{display:inline-block;position:relative}div::before{pointer-events:none;content:\"\";position:absolute;right:10px;top:50%;transform:translateY(-50%);background-image:url(\"data:image/svg+xml,%3Csvg width='10' height='7' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4.95 6.9L0 1.95 1.414.536 4.95 4.07 8.485.536 9.9 1.95 4.95 6.9z' fill='%233B3B3B' fill-rule='evenodd'/%3E%3C/svg%3E\");background-repeat:no-repeat;width:10px;height:7px;transition:0.2s all linear;opacity:0.6}div.disabled{pointer-events:none}div.disabled::before{opacity:0.5}div.disabled select{color:var(--cm-color-ui-light3)}div:hover::before{opacity:0.8}div:active::before{opacity:1}select{-moz-appearance:none;-webkit-appearance:none;appearance:none;box-sizing:border-box;height:30px;background:var(--cm-color-ui-light4);border:1px solid var(--cm-color-ui-light3);border-radius:3px;padding:5px 30px 5px 10px;color:var(--cm-color-ui-dark4);font-family:var(--cm-font-text);font-size:14px;transition:0.2s all linear}select:focus{outline:none;box-shadow:0px 0px 0px 1px var(--cm-color-focus-inner-neutral), 0px 0px 0px 4px var(--cm-color-focus-outer-neutral)}select:hover{background:var(--cm-color-ui-light2);border-color:var(--cm-color-ui-light3)}select:active{background:var(--cm-color-ui-light1)}";

const CmSelect = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.cmInput = createEvent(this, "cmInput", 7);
    this.disabled = false;
    this.options = [];
  }
  /**
   * Selects an option based on the passed index. Respects the disabled state unless forced.
   */
  async selectOptionByIndex(options) {
    if (!this.disabled || options.forceSelection) {
      let select = this.element.shadowRoot.querySelector('select');
      select.selectedIndex = options.selectedIndex;
    }
  }
  inputHandler(event) {
    let select = event.target;
    this.cmInput.emit({
      newValue: select.options[select.selectedIndex].value,
    });
  }
  render() {
    let classes = {
      disabled: this.disabled,
    };
    let renderedOptions = [];
    for (let option of this.options) {
      renderedOptions.push(h("option", { value: option.value }, option.label));
    }
    return (h(Host, null, h("div", { class: classes }, h("select", { onInput: this.inputHandler.bind(this) }, renderedOptions))));
  }
  get element() { return getElement(this); }
};
CmSelect.style = cmSelectCss;

const cmTextCss = "span{display:inline;font-family:var(--cm-font-text);font-size:14px;font-weight:400;color:var(--cm-color-ui-light6)}";

const CmText = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  render() {
    return (h(Host, null, h("span", null, h("slot", null))));
  }
};
CmText.style = cmTextCss;

const cmToggleCss = ":host{display:inline-block}.container:focus{outline:none}.container:focus-visible .toggle{box-shadow:0px 0px 0px 1px var(--cm-color-focus-inner-neutral2), 0px 0px 0px 4px var(--cm-color-focus-outer-neutral)}.toggle{position:relative;display:inline-block;height:18px;width:30px;background:var(--cm-color-ui-light3);border-radius:9px;vertical-align:bottom;transition:all 0.2s linear}.toggle::before{content:\"\";position:absolute;top:3px;left:3px;height:12px;width:12px;border-radius:12px;background:white;transition:all 0.2s linear}.toggle.checked{background:var(--cm-color-button-blue4)}.toggle.checked::before{left:15px}.toggle.checked.disabled{background:var(--cm-color-blue-base)}.toggle:not(.checked).disabled{background:var(--cm-color-ui-light5)}label{display:inline-block;padding-left:8px;user-select:none;font-family:var(--cm-font-text);font-size:14px;height:20px;line-height:20px}label:empty{display:none}";

const CmToggle = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.cmInput = createEvent(this, "cmInput", 7);
    this.label = '';
    this.checked = false;
    this.disabled = false;
    /**
     * Enables `cmInput` Events being emitted when the checked attribute changes.
     */
    this.enableAttributeEmit = false;
  }
  checkedChangeHandler() {
    if (this.enableAttributeEmit) {
      this.cmInput.emit({ isChecked: this.checked, triggeredBy: 'API' });
    }
  }
  handleKeyDown(event) {
    if (event.key === ' ') {
      if (!this.disabled) {
        this.toggleCheck({ triggeredBy: 'User' });
        event.preventDefault();
      }
    }
  }
  handleClick() {
    if (!this.disabled) {
      this.toggleCheck({ triggeredBy: 'User' });
    }
  }
  /**
   * Toggles the checked state. Respects the disabled state, unless forced.
   */
  async toggleCheck(options = {}) {
    var _a;
    if (!this.disabled || options.forceToggle) {
      this.checked = !this.checked;
      this.cmInput.emit({
        isChecked: this.checked,
        triggeredBy: (_a = options.triggeredBy) !== null && _a !== void 0 ? _a : 'API',
      });
    }
  }
  /**
   * Sets the checked state to true. Respects the disabled state, unless forced.
   */
  async check(options = {}) {
    var _a;
    if (!this.disabled || options.forceCheck) {
      if (this.checked === false) {
        this.checked = true;
        this.cmInput.emit({
          isChecked: this.checked,
          triggeredBy: (_a = options.triggeredBy) !== null && _a !== void 0 ? _a : 'API',
        });
      }
    }
  }
  /**
   * Sets the checked state to false. Respects the disabled state, unless forced.
   */
  async uncheck(options = {}) {
    var _a;
    if (!this.disabled || options.forceUncheck) {
      if (this.checked === true) {
        this.checked = false;
        this.cmInput.emit({
          isChecked: this.checked,
          triggeredBy: (_a = options.triggeredBy) !== null && _a !== void 0 ? _a : 'API',
        });
      }
    }
  }
  render() {
    let toggleClasses = {
      toggle: true,
      checked: this.checked,
      disabled: this.disabled,
    };
    let tabIndex = 0;
    if (this.disabled) {
      tabIndex = -1;
    }
    return (h(Host, null, h("div", { class: "container", tabindex: tabIndex }, h("div", { class: toggleClasses, ref: (element) => (this.toggle = element), role: "checkbox", "aria-disabled": this.disabled }), h("label", { onClick: () => {
        if (!this.disabled) {
          this.toggle.focus();
        }
      } }, this.label))));
  }
  static get watchers() { return {
    "checked": ["checkedChangeHandler"]
  }; }
};
CmToggle.style = cmToggleCss;

export { CmBanner as cm_banner, CmButton as cm_button, CmCard as cm_card, CmCheckbox as cm_checkbox, CmContext as cm_context, CmDatalist as cm_datalist, CmDatalistItem as cm_datalist_item, CmDropdown as cm_dropdown, CmEntityList as cm_entity_list, CmFilter as cm_filter, CmFooter as cm_footer, CmHeader as cm_header, CmIcon as cm_icon, CmIconButton as cm_icon_button, CmLink as cm_link, CmLoader as cm_loader, CmLogo as cm_logo, CmModal as cm_modal, CmNotification as cm_notification, CmNotificationContainer as cm_notification_container, CmPage as cm_page, CmPageTab as cm_page_tab, CmPageTabHandle as cm_page_tab_handle, CmSelect as cm_select, CmText as cm_text, CmToggle as cm_toggle };
